import { COCP } from '../constants/AppConstants';
import { uploadPOAAndPOIProof } from './uploadUtils';
import { ImageStore } from './userImageUploadUtils';
import { closeWebView, detectEsimDevice, fetchEID, isMobileApp, isNativeApp, isNewIOSApp } from '@airtel-lego/native-app-bridge';
import { debounce } from '@airtel/air-design-system';
import { fireLogWithSentryBase } from '@airtel-lego/sentry';

export const generateUniqueId = () => {
   const crypto = window.crypto || (window as any).msCrypto; // For IE 11 support
   const array = new Uint8Array(16);
   crypto.getRandomValues(array);

   // Set the version to 4 (UUID version 4)
   array[6] = (array[6] & 0x0f) | 0x40;
   // Set the variant to RFC 4122
   array[8] = (array[8] & 0x3f) | 0x80;

   const toHex = (num: number): string => num.toString(16).padStart(2, '0');

   const interactionId = `${toHex(array[0])}${toHex(array[1])}${toHex(array[2])}${toHex(
      array[3]
   )}-${toHex(array[4])}${toHex(array[5])}-${toHex(array[6])}${toHex(array[7])}-${toHex(
      array[8]
   )}${toHex(array[9])}-${toHex(array[10])}${toHex(array[11])}${toHex(array[12])}${toHex(
      array[13]
   )}${toHex(array[14])}${toHex(array[15])}`;

   return interactionId;
};

export const getInteractionId = (getState: any, onUserAction: any) => {
   const { storeValues } = getState();
   const kycId = storeValues?.skycInteractionId?.interactionId;
   const sessionInteractionId = sessionStorage.getItem('interactionId');
   if (kycId) {
      fireAnalytics(onUserAction, "impression",
         {
            "eVar33": "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
            "eVar21": "{{storeValues:appData.msisdn}}",
            "eVar20": "{{storeValues:appData.loggedInNumber}}",
            "eventCategory": "NEW_ACQ_POSTPAID_SKYC",
            "city": "{{storeValues:pincodeContext.pincodeDetails.city}}",
            "customValue": "",
            "eVar36": "{{storeValues:numberContext.selectedNumber}}",
            "eVar25": "{{storeValues:pincodeContext.pincodeDetails.circleId}}",
            "isInteractive": 0,
            "cartId": "{{storeValues:orderData.cartItemId}}",
            "section": "",
            "eventAction": "impression",
            "eventLabel": "kycID fetched from redux",
            "prop5": "{{storeValues:planInfo.planId}}",
            "eventValue": "",
            "eVar0": "skyc_kycID fetched from redux",
            "subSection": "",
            "customLabel": "card",
            "prop45": "{{storeValues:appData.orderType}}",
            "ticketId": "{{storeValues:orderData.cartId}}",
            "prop26": ""
         }
      );
      return kycId
   } else if (sessionInteractionId) {
      fireAnalytics(onUserAction, "impression",
         {
            "eVar33": "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
            "eVar21": "{{storeValues:appData.msisdn}}",
            "eVar20": "{{storeValues:appData.loggedInNumber}}",
            "eventCategory": "NEW_ACQ_POSTPAID_SKYC",
            "city": "{{storeValues:pincodeContext.pincodeDetails.city}}",
            "customValue": "",
            "eVar36": "{{storeValues:numberContext.selectedNumber}}",
            "eVar25": "{{storeValues:pincodeContext.pincodeDetails.circleId}}",
            "isInteractive": 0,
            "cartId": "{{storeValues:orderData.cartItemId}}",
            "section": "",
            "eventAction": "impression",
            "eventLabel": "kycID fetched from session storage",
            "prop5": "{{storeValues:planInfo.planId}}",
            "eventValue": "",
            "eVar0": "skyc_kycID fetched from session storage",
            "subSection": "",
            "customLabel": "card",
            "prop45": "{{storeValues:appData.orderType}}",
            "ticketId": "{{storeValues:orderData.cartId}}",
            "prop26": ""
         }
      );
      return sessionInteractionId;
   } else {
      fireAnalytics(onUserAction, "impression",
         {
            "eVar33": "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
            "eVar21": "{{storeValues:appData.msisdn}}",
            "eVar20": "{{storeValues:appData.loggedInNumber}}",
            "eventCategory": "NEW_ACQ_POSTPAID_SKYC",
            "city": "{{storeValues:pincodeContext.pincodeDetails.city}}",
            "customValue": "",
            "eVar36": "{{storeValues:numberContext.selectedNumber}}",
            "eVar25": "{{storeValues:pincodeContext.pincodeDetails.circleId}}",
            "isInteractive": 0,
            "cartId": "{{storeValues:orderData.cartItemId}}",
            "section": "",
            "eventAction": "impression",
            "eventLabel": "kycID not found in redux or session storage",
            "prop5": "{{storeValues:planInfo.planId}}",
            "eventValue": "",
            "eVar0": "skyc_kycID not found in redux or session storage",
            "subSection": "",
            "customLabel": "card",
            "prop45": "{{storeValues:appData.orderType}}",
            "ticketId": "{{storeValues:orderData.cartId}}",
            "prop26": ""
         }
      );
   }
};

export const storeInteractionId = (onUserAction: any, getState: any) => {

   const interactionId = generateUniqueId();

   return onUserAction?.({
      actions: [
         {
            type: 'storeValuesInRedux',
            payload: {
               context: 'skycInteractionId',
               data: {
                  interactionId: getInteractionId(getState, onUserAction) || interactionId,
               },
            },
         },
      ],
   });
};

export const fireAnalytics = (onUserAction: any, eventAction: any, data: any) => {
   const actions = [];
   const analytics = {
      analyticsAction: eventAction,
      analyticsData: {
         ...data,
      },
   };

   actions.push(analytics);

   return onUserAction({ actions: actions });
};

export const generateChangeActions = ({ args, data, onUserAction, getState }: any) => {
   const currStepName = args?.[0]?.stepName as string;
   const { storeValues } = getState();
   const isNewSKYCJourney = storeValues?.journeyContext?.journey === 'SKYC_NEW';
   const subHeadingContext = storeValues?.subHeadingContext;
   const { serviceSubHeading, addressSubHeading, portingSubHeading } = subHeadingContext ?? {};
   const selectedMsisdn = storeValues?.numberContext?.selectedNumber || storeValues?.trackOrderContext?.selectedMsisdn;

   let isPrepaidSimLayout = storeValues?.journeyContext?.layout === 'prepaid_sim_layout'
   let isCocpLayout = storeValues?.journeyContext?.layout === 'cocp_to_retail'
   let pathName = window?.location?.pathname;
   let isSimActivationJourney = pathName?.includes("sim-activation")

   const stepsName = [
      'step1Widget',
      'step2Widget',
      'step3Widget',
      'step4Widget',
      'step5Widget',
      'step6Widget',
      'step7Widget',
      'DISABILITY_INFO',
      'CURRENT_ADDRESS_DETAILS',
      'LOCAL_REFERENCE_DETAILS',
      'CURRENT_ADDRESS_DETAILS_NEW',
      'IDENTITY_PROOF',
      'ServiceSelectionWidget',
      'UserDetailsWidget',
      'PortingDetailsWidget',
      'PlanListWidget',
      'NumberSelectionWidget',
      'IntentSelection',
      'SimScannerWidget',
      'simNumberWidget',
      'mnpWidget',
      'numberWidget',
      'addressWidget',
      'PlanListWidget',
      'portingNumberWidget',
      'portingFormDwebWidget',
      'UserBillingInformationWidget'
   ];

   const actions: any = stepsName.map((eventName) => {
      if (eventName !== currStepName) {
         return {
            type: 'nativeEventEmitter',
            payload: {
               eventName: eventName,
               eventData: {
                  isExpanded: false,
                  ...(isSimActivationJourney && {
                     "linkListItemProps.actionType": "button"
                  })
               },
            },
         };
      }

      return {
         type: 'nativeEventEmitter',
         payload: {
            eventName: currStepName,
            eventData: {
               isExpanded: true,
               state: 'none',
               ...(isSimActivationJourney && {
                  "linkListItemProps.actionType": "none"
               })
            },
         },
      };
   });

   if (isNewSKYCJourney) {
      const widgetConfig = [
         {
            stepName: "portingFormDwebWidget",
            payload: {
               shouldShowActionCta: true,
               "linkListItemProps:subHeading": portingSubHeading,
            },
         },
         {
            stepName: "NumberSelectionWidget",
            payload: {
               "stepDetailsProps:subHeading": "{{storeValues:numberContext.selectedNumber}}",
            },
         },
         {
            stepName: "ServiceSelectionWidget",
            payload: {
               "stepDetailsProps:subHeading": serviceSubHeading,
            },
         },
         {
            stepName: "addressWidget",
            payload: {
               "linkListItemProps:subHeading": addressSubHeading,
            },
         },
      ];

      widgetConfig.forEach(({ stepName, payload }) => {
         if (currStepName !== stepName) {
            actions?.push({
               payload: {
                  eventData: payload,
                  eventName: stepName,
               },
               type: "nativeEventEmitter",
            });
         }
      });
   }

   let eventValueMap: { [key: string]: string } = {
      step2Widget: isPrepaidSimLayout ? 'aadhaar verification' : 'aadhar number',
      step3Widget: isPrepaidSimLayout ? 'confirm aadhaar details' : 'details confirmation',
      CURRENT_ADDRESS_DETAILS: isPrepaidSimLayout ? 'delivery address' : 'current address details',
      CURRENT_ADDRESS_DETAILS_NEW: 'delivery address',
      LOCAL_REFERENCE_DETAILS: 'local reference details',
      step4Widget: 'photo verification',
      step5Widget: 'video verification',
      DISABILITY_INFO: 'disability status',
      numberWidget: isSimActivationJourney ? 'validate mobile number' : 'alternate mobile number',
      addressWidget: 'delivery location details',
      ServiceSelectionWidget: 'select connection type',
      portingFormDwebWidget: 'porting details',
      NumberSelectionWidget: 'new prepaid number',
      PlanListWidget: 'prepaid plan'
      //       PortingDetailsWidget: 'porting details',
      //       UserDetailsWidget: 'service selection',
      //       PlanListWidget: 'postpaid plan',
      //       step6Widget: 'SIM declaration',
   };

   let eVar0Map: { [key: string]: string } = {
      numberWidget: isSimActivationJourney ? 'skyc_sim activation Click on change' : 'skyc_click on change_alternate number',
      step2Widget: 'skyc_click on change_aadhaar verification',
      step3Widget: 'skyc_click on change_confirm aadhaar',
      CURRENT_ADDRESS_DETAILS_NEW: 'skyc_click on change_delivery address',
      LOCAL_REFERENCE_DETAILS: 'skyc_click on change_local reference',
      addressWidget: 'skyc_click on change_delivery location',
      ServiceSelectionWidget: 'skyc_click on connection type',
      portingFormDwebWidget: 'skyc_click on change_porting details',
      NumberSelectionWidget: 'skyc_click on change_new prepaid number',
      PlanListWidget: 'skyc_click on change_prepiad plan'
   };

   //only for acq page
   let sectionMap: { [key: string]: string } = {
      numberWidget: 'Step1',
      addressWidget: 'Step2',
      ServiceSelectionWidget: 'Step3',
      portingNumberWidget: 'Step4_porting',
      portingFormDwebWidget: 'Step4_porting',
      NumberSelectionWidget: 'Step4',
      PlanListWidget: 'Step5'
   };

   //mapping for COCP journey
   let cocpEventValueMap: { [key: string]: string } = {
      numberWidget: 'enter your mobile number',
      UserBillingInformationWidget: 'contact details',
      addressWidget: 'address to view plans',
      PlanListWidget: 'view plans',
   };

   let cocpeVar0Map: { [key: string]: string } = {
      numberWidget: 'cocp_mobile number change click',
      UserBillingInformationWidget: 'cocp_contact details change click',
      addressWidget: 'cocp_address change click',
      PlanListWidget: 'cocp_plans change click',
   };

   //only for acq page
   let cocpSectionMap: { [key: string]: string } = {
      numberWidget: 'Step1',
      UserBillingInformationWidget: 'Step2',
      addressWidget: 'Step3',
      PlanListWidget: 'Step4'
   };

   //mapping for GTM tags
   let stepNameMap: { [key: string]: string } = {
      addressWidget: '2|Location Details',
      PlanListWidget: '5|Select Plan'
   };

   let eventMap: { [key: string]: string } = {
      addressWidget: 'step2_change',
      PlanListWidget: 'change_plan'
   };

   const eventValue = eventValueMap[currStepName];
   if (isNewSKYCJourney && !isPrepaidSimLayout) {
      actions?.push({
         analyticsAction: 'click',
         analyticsData: {
            eventCategory: pathName?.includes('kyc/verification')
               ? 'NEW_ACQ_POSTPAID_SKYC'
               : 'NEW_ACQ_POSTPAID_SKYC_LANDING_PAGE',
            section: 'stepsSection',
            subSection: currStepName,
            eventAction: 'click',
            eventLabel: 'change',
            eventValue,
            customValue: '',
            customLabel: 'button',
            prop35: '{{storeValues:orderData.orderData.cartId}}',
            extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
            prop45: '{{storeValues:appData.subJourney}}',
            eVar21: '{{storeValues:appData.loggedInNumber}}',
            eVar36: '{{storeValues:appData.msisdn}}',
            city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
            eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
            prop4: 'SKYC',
            extraData11: '{{storeValues:layoutContext.layout}}',
            prop7: '{{storeValues:outstationContext.isOutstation}}',
            prop9: '{{storeValues:appData.lob}}',
         },
      });
   } else if (isNewSKYCJourney && isPrepaidSimLayout) {
      actions?.push({
         analyticsAction: 'click',
         analyticsData: {
            eventCategory: pathName?.includes('kyc/verification')
               ? 'NEW_ACQ_POSTPAID_SKYC'
               : 'NEW_ACQ_POSTPAID_SKYC_LANDING_PAGE',
            section: sectionMap[currStepName] ?? 'stepsSection',
            subSection: currStepName,
            eVar33: "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
            eVar21: "{{storeValues:appData.msisdn}}",
            eVar20: "{{storeValues:appData.loggedInNumber}}",
            city: "{{storeValues:pincodeContext.pincodeDetails.city}}",
            customValue: "",
            eVar36: selectedMsisdn,
            eVar25: "{{storeValues:pincodeContext.pincodeDetails.circleId}}",
            isInteractive: 1,
            cartId: "{{storeValues:orderData.cartItemId}}",
            eventAction: "click",
            eventLabel: "change",
            prop5: "{{storeValues:planInfo.planName}}",
            prop4: "SKYC",
            eventValue,
            eVar0: eVar0Map[currStepName],
            customLabel: "card",
            prop45: "{{storeValues:appData.orderType}}",
            ticketId: "{{storeValues:orderData.cartId}}",
            prop26: ""
         }
      });

      if (currStepName == "addressWidget" || currStepName == "PlanListWidget") {
         actions?.push({
            payload: {
               args: [
                  {
                     dataLayer: {
                        stepName: stepNameMap[currStepName],
                        event: eventMap[currStepName],
                        clicktext: 'change'
                     },
                  },
               ],
               utilName: 'handleGtmDataLayerEvent',
            },
            type: 'callUtilFunction',
         },)
      }
   } else if (isNewSKYCJourney && isCocpLayout) {
      actions?.push({
         analyticsAction: 'click',
         analyticsData: {
            eventCategory: pathName?.includes('kyc/verification')
               ? 'NEW_ACQ_POSTPAID_SKYC'
               : 'NEW_ACQ_POSTPAID_SKYC_LANDING_PAGE',
            section: cocpSectionMap[currStepName] ?? 'stepsSection',
            subSection: currStepName,
            eVar33: "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
            eVar21: "{{storeValues:appData.msisdn}}",
            eVar20: "{{storeValues:appData.loggedInNumber}}",
            city: "{{storeValues:pincodeContext.pincodeDetails.city}}",
            customValue: "",
            eVar36: "{{storeValues:appData.msisdn}}",
            eVar25: "{{storeValues:pincodeContext.pincodeDetails.circleId}}",
            isInteractive: 1,
            cartId: "{{storeValues:orderData.cartItemId}}",
            eventAction: "click",
            eventLabel: "change",
            prop5: "{{storeValues:planInfo.planName}}",
            prop4: "SKYC",
            eventValue: cocpEventValueMap[currStepName],
            eVar0: cocpeVar0Map[currStepName],
            customLabel: "button",
            ticketId: "{{storeValues:orderData.cartId}}",
            prop26: "",
            prop45: "cocp",
         }
      });

   }
   if (isSimActivationJourney) {
      actions?.push({
         analyticsAction: "click",
         analyticsData: {
            eVar0: eVar0Map[currStepName],
            eventCategory: "sim_activation_page",
            section: "stepsSection",
            subSection: currStepName,
            eventAction: "click",
            eventLabel: "change",
            eventValue,
            customValue: "",
            customLabel: "card",
            prop4: "SKYC",
            isInteractive: 1,
            ticketId: storeValues?.orderData?.cartId,
            cartId: storeValues?.orderData?.cartItemId,
            eVar20: storeValues?.appData?.loggedInNumber,
            eVar21: storeValues?.appData?.msisdn,
            prop5: "",
            prop45: "",
            prop26: "",
            eVar36: storeValues?.trackOrderContext?.selectedMsisdn,
            city: storeValues?.pincodeContext?.pincodeDetails?.city,
            eVar25: storeValues?.pincodeContext?.pincodeDetails?.circleId,
            eVar33: storeValues?.pincodeContext?.pincodeDetails?.pincode
         },
      });
   }
   return onUserAction({
      actions: actions,
   });
};

export const handleUpdateDob = ({ additionalData, onUserAction, getState, args }: any) => {
   const { storeValues } = getState();
   const { value, dob } = additionalData?.dataFromWidget ?? {};
   const { DobUpdateStatus, skycInteractionId, journeyContext = {}, pincodeContext } = storeValues ?? {};
   const isAllowed = DobUpdateStatus?.isUpdated ?? false;
   const interactionId = skycInteractionId?.interactionId;
   const journey = journeyContext?.layout;
   const formattedDob = dob.split('-').reverse().join('-');
   const isOutstation = args[0]?.isOutstation
   const isPrepaidSimLayout = args[0]?.layout === "prepaid_sim_layout"
   const isReverificationJourney = journey == "reverification_journey"

   let eventName = (isPrepaidSimLayout && !isOutstation) ? "CURRENT_ADDRESS_DETAILS_NEW" : "CURRENT_ADDRESS_DETAILS"
   if (isReverificationJourney) {
      eventName = "step4Widget"
   }


   if (isAllowed) {
      return onUserAction({
         actions: [
            {
               payload: {
                  requestType: 'POST',
                  apiUrl: 'guardian/api/skyc/updateDOB/v1',
                  authTokenGroup: 'SKYC_REVERIFICATION',
                  body: {
                     interactionId: interactionId,
                     dateOfBirth: dob,
                  },
               },
               type: 'apiCall',
            },
            {
               analyticsAction: 'click',
            },
            {
               type: 'storeValuesInRedux',
               payload: {
                  context: 'kycDetails',
                  data: {
                     guardianName: value,
                     dob,
                  },
               },
            },
         ],
      });
   } else {
      const { street, area } = splitStreet1(storeValues?.billingAddressContext?.street1 || "");
      let actions: any = [
         {
            type: 'storeValuesInRedux',
            payload: {
               context: 'kycDetails',
               data: {
                  guardianName: value,
                  dob: journey === 'SKYC_NEW' ? formattedDob : dob,
               },
            },
         },
         {
            payload: {
               eventData: {
                  isExpanded: false,
                  state: 'success',
               },
               eventName: 'step3Widget',
            },
            type: 'nativeEventEmitter',
         },
         {
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: 'SKYC_LANDING_PAGE',
               section: 'stepssection',
               subSection: 'Step3Widget',
               eventAction: 'pageclose',
               eVar21: '{{storeValues:appData.msisdn}}',
               extraData11: '{{storeValues:layoutContext.layout}}',
               prop8: 'reverification',
               prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
               prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
               prop5: '{{storeValues:outstationContext.isOutstation}}',
            },
         },
         {
            payload: {
               eventData: {
                  isExpanded: true,
                  state: 'none',
                  ...(isPrepaidSimLayout && eventName === "CURRENT_ADDRESS_DETAILS" && (() => {
                     return {
                        "inputsDataProps.houseNo.value": "",
                        "inputsDataProps.street.value": street,
                        "inputsDataProps.area.value": area,
                        "inputsDataProps.landmark.value": "",
                        "inputsDataProps.pinCode.isValid": true,
                        "inputsDataProps.pinCode.isDisabled": true,
                     };
                  })()),
               },
               eventName: eventName,
            },
            type: 'nativeEventEmitter',
         }
      ]
      if (isPrepaidSimLayout && eventName == "CURRENT_ADDRESS_DETAILS" && street) {
         actions.push({
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: "new_acq_postpaid_skyc",
               section: "stepsSection",
               subSection: "CURRENT_ADDRESS_DETAILS",
               eVar33: "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
               eVar21: "{{storeValues:appData.msisdn}}",
               eVar20: "{{storeValues:appData.loggedInNumber}}",
               city: "{{storeValues:pincodeContext.pincodeDetails.city}}",
               customValue: "",
               eVar36: "{{storeValues:trackOrderContext.selectedMsisdn}}",
               eVar25: "{{storeValues:pincodeContext.pincodeDetails.circleId}}",
               isInteractive: 0,
               cartId: "{{storeValues:orderData.cartItemId}}",
               eventAction: "impression",
               eventLabel: "enter street/road name",
               prop5: "{{storeValues:planInfo.planName}}",
               prop4: "SKYC",
               eventValue: street,
               eVar0: "skyc_autofill of street/road name_delivery address",
               customLabel: "card",
               prop45: "{{storeValues:appData.orderType}}",
               ticketId: "{{storeValues:orderData.cartId}}",
               prop26: ""
            }
         })
      }
      if (isPrepaidSimLayout && eventName == "CURRENT_ADDRESS_DETAILS" && area) {
         actions.push({
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: "new_acq_postpaid_skyc",
               section: "stepsSection",
               subSection: "CURRENT_ADDRESS_DETAILS",
               eVar33: "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
               eVar21: "{{storeValues:appData.msisdn}}",
               eVar20: "{{storeValues:appData.loggedInNumber}}",
               city: "{{storeValues:pincodeContext.pincodeDetails.city}}",
               customValue: "",
               eVar36: "{{storeValues:trackOrderContext.selectedMsisdn}}",
               eVar25: "{{storeValues:pincodeContext.pincodeDetails.circleId}}",
               isInteractive: 0,
               cartId: "{{storeValues:orderData.cartItemId}}",
               eventAction: "impression",
               eventLabel: "enter area/sector",
               prop5: "{{storeValues:planInfo.planName}}",
               prop4: "SKYC",
               eventValue: area,
               eVar0: "skyc_autofill of area/sector/locality_delivery address",
               customLabel: "card",
               prop45: "{{storeValues:appData.orderType}}",
               ticketId: "{{storeValues:orderData.cartId}}",
               prop26: ""
            }
         })
      }
      return onUserAction({
         actions: actions,
      });
   }
};

export const handleValidSimDeclaration = ({
   args,
   additionalData,
   onUserAction,
   getState,
}: any) => {
   const {
      providerDetails,
      providerDetailsText,
      simOwnerDetails,
      selectedTotalConnectionCount,
      multipleConnectionReason,
   } = additionalData?.dataFromWidget ?? {};
   const { storeValues } = getState();
   const { isNESACircle, isJKCircle } = storeValues?.siNumberStatusDetails || {};
   const isNewSKYCJourney = storeValues?.journeyContext?.journey === 'SKYC_NEW';

   const actions: any[] = [
      {
         payload: {
            eventData: {
               state: 'success',
               isExpanded: false,
            },
            eventName: 'step6Widget',
         },
         type: 'nativeEventEmitter',
      },
      {
         payload: {
            data: {
               providerDetailsText,
               simOwnerDetails: simOwnerDetails?.length ? simOwnerDetails : [],
               selectedTotalConnectionCount,
               multipleConnectionReason,
            },
            context: 'simDeclarationWidgetData',
         },
         type: 'storeValuesInRedux',
      },
      {
         payload: {
            data: {
               totalCount: selectedTotalConnectionCount,
               connections:
                  selectedTotalConnectionCount > 0
                     ? providerDetails?.map(
                        ({ provider, count }: { provider: string; count: number }) => ({
                           operator: provider,
                           count: count?.toString(),
                        })
                     )
                     : [],
            },
            context: 'otherConnections',
         },
         type: 'storeValuesInRedux',
      },
   ];

   if (isNESACircle || isJKCircle) {
      actions.push({
         payload: {
            eventData: {
               state: 'none',
               isExpanded: true,
            },
            eventName: 'step7Widget',
         },
         type: 'nativeEventEmitter',
      });
   } else {
      actions.push({
         payload: {
            eventData: {
               state: 'none',
               isExpanded: true,
            },
            eventName: 'DISABILITY_INFO',
         },
         type: 'nativeEventEmitter',
      });
      if (isNewSKYCJourney) {
         actions?.push({
            analyticsAction: 'impression',
            analyticsData: {
               eventCategory: 'NEW_ACQ_POSTPAID_SKYC',
               section: 'stepsSection',
               subSection: 'DISABILITY_INFO',
               eventAction: 'pageloaded',
               eventLabel: '',
               eventValue: '',
               customValue: '',
               customLabel: '',
               prop35: '{{storeValues:orderData.orderData.cartId}}',
               extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
               prop45: '{{storeValues:appData.subJourney}}',
               eVar21: '{{storeValues:appData.loggedInNumber}}',
               eVar36: '{{storeValues:appData.msisdn}}',
               city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
               eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
               prop4: 'SKYC',
               extraData11: '{{storeValues:layoutContext.layout}}',
               prop7: '{{storeValues:outstationContext.isOutstation}}',
               prop9: '{{storeValues:appData.lob}}',
            },
         });
      } else {
         actions.push({
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: 'SKYC_LANDING_PAGE',
               section: 'stepssection',
               subSection: 'DISABILITY_INFO',
               eventAction: 'pageloaded',
               eVar21: '{{storeValues:appData.msisdn}}',
               extraData11: '{{storeValues:layoutContext.layout}}',
               prop8: 'reverification',
               prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
               prop5: '{{storeValues:outstationContext.isOutstation}}',
            },
         });
      }
   }

   onUserAction?.({
      actions,
   });
};

export const prepareDisabilityValidFormMetaData = ({
   additionalData,
   onUserAction,
   getState,
   collapseDelay = 100,
}: any) => {
   const {
      frontFile,
      disability,
      backFile,
      dropdownValue,
      disabilityPercent,
      videoRequired,
      type,
   } = additionalData?.dataFromWidget ?? {};

   const { storeValues } = getState();
   const { siNumberStatusDetails, outstationContext, journeyContext } =
      storeValues ?? {};
   const { actionRequired } = siNumberStatusDetails || {};
   const { isOutstation } = outstationContext || {};
   const { journey, layout } = journeyContext || {};
   const orderSubType = storeValues?.trackOrderContext?.orderSubType;

   const isPrepaidSimLayout = layout === 'prepaid_sim_layout';
   const utmLayout = storeValues?.additionalData?.queryParams?.utm_layout || '';
   const isCocpToRetailLayout = utmLayout === 'cocp_to_retail';

   const { isFrontImageUploaded } = storeValues?.pwdData || {};

   // During front upload success, Redux may not yet have isFrontImageUploaded=true.
   // So the current front upload also counts as uploaded.
   const willHaveFrontImage =
      isFrontImageUploaded || type === 'front';

   // CTA is valid:
   // - immediately for "No"
   // - for "Yes" only after disability type, disability percentage, and front image are available
   const isDisabilityValidForLayout =
      disability?.toLowerCase() !== 'yes' ||
      (!!willHaveFrontImage && !!dropdownValue && !!disabilityPercent);

   const actions: any[] = [
      {
         payload: {
            eventData: {
               state: 'success',
               isExpanded: false,
            },
            eventName: 'DISABILITY_INFO',
         },
         actionWithDelayed: collapseDelay,
         type: 'nativeEventEmitter',
      },
      {
         payload: {
            data: {
               frontFile,
               disability,
               backFile,
               dropdownValue,
               disabilityPercent,
               videoRequired,
            },
            context: 'disabilityWidgetData',
         },
         type: 'storeValuesInRedux',
      },
   ];

   if (isCocpToRetailLayout) {
      // cocp_to_retail: enable button + show TNC checkbox + reset isValid (was set false by onInValidFormMetaData)
      actions.push(
         {
            payload: {
               eventData: {
                  leftCta: {
                     disabled: false,
                     buttonType: 'primary',
                     size: 'md',
                     title: 'Save & Review Details',
                  },
               },
               eventName: 'FinalSubmitButton_submitButton',
            },
            type: 'nativeEventEmitter',
         },
         {
            type: 'nativeEventEmitter',
            payload: {
               eventData: {
                  isValid: true,
                  checkboxData: {
                     label: 'I declare that the above information is true',
                     actionCta: 'Read More',
                  },
                  onActionCtaPressMetaData: {
                     id: 'onActionPress',
                     actions: [
                        {
                           payload: {
                              modalData: [],
                              modalSection: 'FinalTNCModalSection',
                           },
                           type: 'openModal',
                        },
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eVar33: '{{storeValues:pincodeContext.pincodeDetails.pincode}}',
                              eVar21: '{{storeValues:appData.msisdn}}',
                              eVar20: '{{storeValues:appData.loggedInNumber}}',
                              eventCategory: 'new_acq_postpaid_skyc',
                              city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                              customValue: '',
                              eVar36: '{{storeValues:trackOrderContext.selectedMsisdn}}',
                              eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleId}}',
                              isInteractive: 1,
                              cartId: '{{storeValues:orderData.cartItemId}}',
                              section: 'FinalSubmitButton',
                              eventAction: 'click',
                              eventLabel: 'readmore',
                              prop5: '{{storeValues:planInfo.planName}}',
                              prop4: 'SKYC',
                              eventValue: '',
                              eVar0: 'skyc_click on read more tnc',
                              subSection: 'submitButton',
                              customLabel: 'button',
                              prop45: '{{storeValues:appData.orderType}}',
                              ticketId: '{{storeValues:orderData.cartId}}',
                              prop26: '',
                           },
                        },
                     ],
                  },
                  'buttonData.leftCta.title': 'Save & Review Details',
               },
               eventName: 'FinalSubmitButton_submitButton',
            },
         }
      );
   } else if (isPrepaidSimLayout) {

      // prepaid_sim_layout: Show "Confirm Details Via OTP"
      actions.push(
         {
            type: 'nativeEventEmitter',
            payload: {
               eventData: {
                  checkboxData: {
                     multiTextLabel: [
                        {
                           text: 'I agree to the ',
                        },
                        {
                           color: '#075ee8',
                           id: '2',
                           isHyperLink: true,
                           hyperLinkPressMetaData: {
                              id: 'onT&C-press',
                              actions: [
                                 {
                                    payload: {
                                       modalData: [],
                                       modalSection: 'FinalTNCModalSection',
                                    },
                                    type: 'openModal',
                                 },
                                 {
                                    analyticsAction: 'click',
                                    analyticsData: {
                                       eVar21: '{{storeValues:appData.loggedInNumber}}',
                                       eventCategory: 'NEW_ACQ_POSTPAID_SKYC',
                                       city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                                       eVar36: '{{storeValues:appData.msisdn}}',
                                       eVar25:
                                          '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
                                       section: 'FinalSubmitButton',
                                       eventAction: 'click',
                                       eventLabel: 'readmore',
                                       eventValue: '',
                                       prop4: 'SKYC',
                                       extraData11: '{{storeValues:layoutContext.layout}}',
                                       extraData12:
                                          '{{storeValues:orderData.orderData.cartItemId}}',
                                       subSection: 'submitButton',
                                       customLabel: 'button',
                                       customValue: '',
                                       prop35: '{{storeValues:orderData.orderData.cartId}}',
                                       prop45: '{{storeValues:appData.subJourney}}',
                                       prop7: '{{storeValues:outstationContext.isOutstation}}',
                                       prop9: '{{storeValues:appData.lob}}',
                                    },
                                 },
                              ],
                           },
                           text: 'Terms & Conditions ',
                           type: 'body-hyperlink-sm',
                        },
                        {
                           text: orderSubType == "MNP" ? 'of porting.' : 'for the new Prepaid SIM.',
                        }]
                  },
                  isValid: isDisabilityValidForLayout,
                  "buttonData.leftCta": {
                     "buttonType": "primary",
                     "size": "md",
                     "title": "Confirm Details Via OTP",
                     "titleProps": {
                        "text": "Confirm Details Via OTP"
                     },
                  },
                  onActionCtaPressMetaData: {
                     id: 'onActionPress',
                     actions: [
                        {
                           payload: {
                              modalData: [],
                              modalSection: 'FinalTNCModalSection',
                           },
                           type: 'openModal',
                        },
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eVar21: '{{storeValues:appData.loggedInNumber}}',
                              eventCategory: 'NEW_ACQ_POSTPAID_SKYC',
                              city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                              eVar36: '{{storeValues:appData.msisdn}}',
                              eVar25:
                                 '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
                              section: 'FinalSubmitButton',
                              eventAction: 'click',
                              eventLabel: 'readmore',
                              eventValue: '',
                              prop4: 'SKYC',
                              extraData11: '{{storeValues:layoutContext.layout}}',
                              extraData12:
                                 '{{storeValues:orderData.orderData.cartItemId}}',
                              subSection: 'submitButton',
                              customLabel: 'button',
                              customValue: '',
                              prop35: '{{storeValues:orderData.orderData.cartId}}',
                              prop45: '{{storeValues:appData.subJourney}}',
                              prop7: '{{storeValues:outstationContext.isOutstation}}',
                              prop9: '{{storeValues:appData.lob}}',
                           },
                        },
                     ],
                  },
               },
               eventName: 'FinalSubmitButton_submitButton',
            },
         }
      );



   } else {
      if (!isOutstation && actionRequired === 'FULL_KYC') {
         const leftCta = {
            disabled: false,
            size: 'md',
            buttonType: 'primary',
            title: 'Verify Via OTP & Submit',
         };
         if (journey === 'SKYC_NEW') {
            actions.push(
               {
                  payload: {
                     eventData: {
                        leftCta: {
                           ...leftCta,
                           title: 'Save & Review Details',
                        },
                     },
                     eventName: 'FinalSubmitButton_submitButton',
                  },
                  type: 'nativeEventEmitter',
               },
               {
                  type: 'nativeEventEmitter',
                  payload: {
                     eventData: {
                        checkboxData: {
                           label: 'I declare that the above information is true',
                           actionCta: 'Read More',
                        },
                        onActionCtaPressMetaData: {
                           id: 'onActionPress',
                           actions: [
                              {
                                 payload: {
                                    modalData: [],
                                    modalSection: 'FinalTNCModalSection',
                                 },
                                 type: 'openModal',
                              },
                              {
                                 analyticsAction: 'click',
                                 analyticsData: {
                                    eVar21: '{{storeValues:appData.loggedInNumber}}',
                                    eventCategory: 'NEW_ACQ_POSTPAID_SKYC',
                                    city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                                    eVar36: '{{storeValues:appData.msisdn}}',
                                    eVar25:
                                       '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
                                    section: 'FinalSubmitButton',
                                    eventAction: 'click',
                                    eventLabel: 'readmore',
                                    eventValue: '',
                                    prop4: 'SKYC',
                                    extraData11: '{{storeValues:layoutContext.layout}}',
                                    extraData12:
                                       '{{storeValues:orderData.orderData.cartItemId}}',
                                    subSection: 'submitButton',
                                    customLabel: 'button',
                                    customValue: '',
                                    prop35: '{{storeValues:orderData.orderData.cartId}}',
                                    prop45: '{{storeValues:appData.subJourney}}',
                                    prop7: '{{storeValues:outstationContext.isOutstation}}',
                                    prop9: '{{storeValues:appData.lob}}',
                                 },
                              },
                           ],
                        },
                        'buttonData.leftCta.title': 'Save & Review Details',
                     },
                     eventName: 'FinalSubmitButton_submitButton',
                  },
               }
            );
         } else {
            actions.push({
               payload: {
                  eventData: {
                     leftCta,
                  },
                  eventName: 'FinalSubmitButton_submitButton',
               },
               type: 'nativeEventEmitter',
            });
            actions.push({
               analyticsAction: 'click',
               analyticsData: {
                  eventCategory: 'SKYC_LANDING_PAGE', // TODO
                  section: 'FinalSubmitButton',
                  subSection: 'submitButton',
                  eventAction: 'enabled',
                  eventLabel: 'verify',
                  eventValue: 'Verify Via OTP & Submit',
                  customLabel: 'final verification',
                  eVar21: '{{storeValues:appData.msisdn}}',
                  extraData11: '{{storeValues:layoutContext.layout}}',
                  prop8: 'reverification',
                  prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
                  prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
                  prop5: '{{storeValues:outstationContext.isOutstation}}',
               },
            });
         }
      } else {
         actions.push({
            payload: {
               eventData: {
                  state: 'none',
                  isExpanded: true,
               },
               eventName: !isCocpToRetailLayout && !isPrepaidSimLayout ? 'CURRENT_ADDRESS_DETAILS' : 'CURRENT_ADDRESS_DETAILS_NEW',
            },
            type: 'nativeEventEmitter',
         });
         if (journey === 'SKYC_NEW') {
            actions?.push({
               analyticsAction: 'impression',
               analyticsData: {
                  eventCategory: 'NEW_ACQ_POSTPAID_SKYC',
                  section: 'stepsSection',
                  subSection: !isCocpToRetailLayout && !isPrepaidSimLayout ? 'CURRENT_ADDRESS_DETAILS' : 'CURRENT_ADDRESS_DETAILS_NEW',
                  eventAction: 'pageloaded',
                  eventLabel: '',
                  eventValue: '',
                  customValue: '',
                  customLabel: '',
                  prop35: '{{storeValues:orderData.orderData.cartId}}',
                  extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
                  prop45: '{{storeValues:appData.subJourney}}',
                  eVar21: '{{storeValues:appData.loggedInNumber}}',
                  eVar36: '{{storeValues:appData.msisdn}}',
                  city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                  eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
                  prop4: 'SKYC',
                  extraData11: '{{storeValues:layoutContext.layout}}',
                  prop7: '{{storeValues:outstationContext.isOutstation}}',
                  prop9: '{{storeValues:appData.lob}}',
               },
            });
         } else {
            actions.push({
               analyticsAction: 'click',
               analyticsData: {
                  eventCategory: 'SKYC_LANDING_PAGE', // TODO
                  section: 'stepssection',
                  subSection: !isCocpToRetailLayout && !isPrepaidSimLayout ? 'CURRENT_ADDRESS_DETAILS' : 'CURRENT_ADDRESS_DETAILS_NEW',
                  eventAction: 'pageloaded',
                  eVar21: '{{storeValues:appData.msisdn}}',
                  extraData11: '{{storeValues:layoutContext.layout}}',
                  prop8: 'reverification',
                  prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
                  prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
                  prop5: '{{storeValues:outstationContext.isOutstation}}',
               },
            });
         }
      }
   }
   return actions;
};

export const handleValidDisabilityInfo = ({
   additionalData,
   onUserAction,
   getState,
}: any) => {
   const { disability } = additionalData?.dataFromWidget ?? {};

   if (disability?.toLowerCase() === 'yes') {
      // For "Yes" case, only collapse if the front image has actually been
      // uploaded to the server. This prevents premature collapse while an
      // upload is still in-flight, but allows collapse when the user fills
      // dropdown / percentage AFTER a successful front-image upload.
      const { storeValues } = getState();
      const { isFrontImageUploaded } = storeValues?.pwdData || {};
      if (!isFrontImageUploaded) return;
   }

   const actions = prepareDisabilityValidFormMetaData({
      additionalData,
      onUserAction,
      getState,
   });

   onUserAction?.({
      actions,
   });
};

export const handleValidLocalReferenceInfo = ({
   additionalData,
   onUserAction,
   getState,
}: any) => {
   const {
      areaInput,
      pinCodeInput,
      cityInput,
      streetInput,
      mobileNumberInput,
      districtInput,
      nameInput,
      houseNoInput,
      stateInput,
      landmarkInput,
   } = additionalData?.dataFromWidget ?? {};
   const { storeValues } = getState();
   const { isJKCircle } = storeValues?.siNumberStatusDetails || {};

   const { journeyContext = {} } = storeValues ?? {};
   const journey = journeyContext?.layout;
   const isReverificationJourney = journey == "reverification_journey"


   const actions: any[] = [
      {
         payload: {
            data: {
               area: areaInput,
               pincode: pinCodeInput,
               city: cityInput,
               street: streetInput,
               mobileNumber: mobileNumberInput,
               district: districtInput,
               name: nameInput,
               houseNo: houseNoInput,
               state: stateInput,
               landmark: landmarkInput,
            },
            context: 'localReferenceDetails',
         },
         type: 'storeValuesInRedux',
      },
      {
         payload: {
            args: [
               {
                  isReferee: true,
               },
            ],
            utilName: 'callSendRefereeAndSubmitOtp',
         },
         type: 'callUtilFunction',
      },
   ];

   // Move forward in the journey: once local-ref is captured, proceed to photo verification.
   // (OTP validate flow/UI is handled by the widget/otp utils; this just ensures the next step is ready.)
   if (isReverificationJourney) {
      actions.push({
         payload: {
            eventData: {
               state: 'none',
               isExpanded: true,
            },
            eventName: 'step4Widget',
         },
         type: 'nativeEventEmitter',
      });
   }


   if (isJKCircle) {
      actions.push({
         payload: {
            eventData: {
               state: 'none',
               isExpanded: true,
            },
            eventName: 'IDENTITY_PROOF',
         },
         type: 'nativeEventEmitter',
      });
   }

   onUserAction?.({
      actions,
   });
};

export const handleThankyouPage = ({ additionalData, onUserAction, getState }: any) => {
   let search = window.location.search;
   let params = new URLSearchParams(search);
   let requestID = params.get('requestID');

   const subtitle = {
      multiText: [
         {
            text: 'Request ID : ',
         },
         {
            text: requestID,
            color: '#027bfc',
            isBold: true,
         },
         {
            text: '\n We will keep you updated regarding its status.',
         },
      ],
      style: {
         marginTop: 7,
      },
      textAlignment: 'center',
   };
   const actions: any[] = [];
   if (requestID) {
      actions.push({
         payload: {
            eventData: {
               subtitle,
            },
            shouldResolveData: true,
            eventName: 'statusCardThankyou',
         },
         type: 'nativeEventEmitter',
      });
   } else {
      actions.push({
         type: 'navigation',
         payload: {
            id: 'redirection',
            screenName: '/reverification',
            shouldAddSearchParams: true,
            params: {},
            type: 'replace',
         },
      });
   }

   return onUserAction?.({
      actions,
   });
};


export const getFullPageLoaderAction = (show: boolean) => {
   return {
      type: 'fullPageLoader',
      payload: {
         show,
      },
   };
};

export const getNativeEventEmitterAction = (eventName: string, eventData: any) => {
   return {
      type: 'nativeEventEmitter',
      payload: {
         eventName,
         eventData,
      },
   };
};

export const getStoreValuesAction = (context: string, data: any) => {
   return {
      type: 'storeValuesInRedux',
      payload: {
         context,
         data,
      },
   };
};

export const getCallUtilFunction = (utilName: string, args: any[]) => {
   return {
      payload: {
         utilName,
         args,
      },
      type: 'callUtilFunction',
   };
};

export const handlePOISameAsPOA = ({ additionalData, onUserAction, getState }: any) => {
   const { checked } = additionalData?.dataFromWidget ?? {};

   const actions: any[] = [
      {
         type: 'storeValuesInRedux',
         payload: {
            context: 'identityProofData',
            data: {
               isPOASameAsPOI: checked,
            },
         },
      },
   ];

   if (checked) {
      const args = {
         additionalData: {
            dataFromWidget: {},
         },
         onUserAction,
         args: [] as string[],
         getState,
      };
      const imageStore = ImageStore.getInstance();

      args.additionalData.dataFromWidget = {
         type: 'identityFront',
         file: imageStore.getItem('addressFront'),
      };
      args.args = ['uploadFrontIdProof', 'true'];
      uploadPOAAndPOIProof(args);

      args.additionalData.dataFromWidget = {
         type: 'identityBack',
         file: imageStore.getItem('addressBack'),
      };
      args.args = ['uploadBackIdProof', 'true'];
      uploadPOAAndPOIProof(args);
   }

   onUserAction?.({
      actions,
   });
};

export const redirectToOrderSummaryPage = ({
   additionalData,
   onUserAction,
   getState,
}: any) => {
   const actions: any[] = [];

   const { storeValues } = getState();
   const lob = storeValues?.appData?.lob;

   if (lob?.toLowerCase() === 'postpaid') {
      const navigationActionObj = {
         payload: {
            delay: 0,
            screenName: '/order-summary',
            type: 'push',
            shouldAddSearchParams: true,
            params: {},
         },
         type: 'navigation',
      };
      actions?.push(navigationActionObj);
   } else {
      actions?.push({
         payload: {
            args: [
               {
                  isReferee: false,
               },
            ],
            utilName: 'callSendRefereeAndSubmitOtp',
         },
         type: 'callUtilFunction',
      });
   }

   return onUserAction?.({
      actions,
   });
};

export const deAllocateNumber = ({ additionalData, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const allocatedNumber = storeValues?.allocatedContext?.allocatedNumber;
   const selectedNumber = storeValues?.numberContext?.selectedNumber;
   const imsiNo = storeValues?.allocatedContext?.imsiNo;
   const lob = storeValues?.appData?.lob;
   const circleId = storeValues?.pincodeContext?.pincodeDetails?.circleId;

   const actions: any[] = [];

   if (!!allocatedNumber && allocatedNumber !== selectedNumber) {
      actions.push({
         type: 'apiCall',
         payload: {
            apiUrl: 'guardian/api/skyc/new/number-status/v1',
            requestType: 'POST',
            body: {
               msisdn: allocatedNumber,
               IMSI: imsiNo,
               lob,
               operationType: 'NUMBER_DEALLOCATE',
               isModal: false,
               circleId,
            },
            header: {},
         },
      });
   }

   return onUserAction?.({
      actions,
   });
};

export const validatePortNumber = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const msisdn = storeValues?.appData?.msisdn;
   const portNumber = storeValues?.numberContext?.selectedNumber;
   const pincode = storeValues?.pincodeContext?.pincodeDetails?.pincode;
   const lob = storeValues?.appData?.lob;
   const flow = storeValues?.appData?.flow;
   const portingWidgetId = storeValues?.portingWidgetId?.id;

   const actions: any[] = [];

   if (portNumber === msisdn) {

      if (flow.toLowerCase() == "prepaidsim") {
         actions?.push({
            payload: {
               eventData: {
                  numberHintText: 'Porting number and alternate number cannot be the same.',
                  numberState: 'error',
               },
               eventName: portingWidgetId,
            },
            type: 'nativeEventEmitter'
         });
      } else {
         actions?.push({
            payload: {
               eventData: {
                  inputsDataProps: {
                     mobileNumber: {
                        hintText:
                           'This number cannot be same as the alternate number. Try with another number.',
                        state: 'error',
                     },
                  },
               },
               eventName: 'PortingDetailsWidget',
            },
            type: 'nativeEventEmitter',
         });
      }

      actions?.push({
         "analyticsAction": "impression",
         "analyticsData": {
            "eVar33": "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
            "eVar21": "{{storeValues:appData.msisdn}}",
            "eVar20": "{{storeValues:appData.loggedInNumber}}",
            "eventCategory": "NEW_ACQ_POSTPAID_SKYC_LANDING_PAGE",
            "city": "{{storeValues:pincodeContext.pincodeDetails.city}}",
            "customValue": "",
            "eVar36": "{{storeValues:numberContext.selectedNumber}}",
            "eVar25": "{{storeValues:pincodeContext.pincodeDetails.circleId}}",
            "isInteractive": 0,
            "cartId": "{{storeValues:orderData.cartItemId}}",
            "section": "Step4_porting",
            "eventAction": "error",
            "eventLabel": "this number cannot be same as the alternate number. try with another number",
            "prop5": "{{storeValues:planInfo.planId}}",
            "eventValue": "porting details",
            "eVar0": "skyc_error impression - porting number same as alternate number",
            "subSection": "portingFormDwebWidget",
            "customLabel": "card",
            "prop45": "{{storeValues:appData.orderType}}",
            "ticketId": "{{storeValues:orderData.cartId}}",
            "prop26": ""
         }
      })
   } else {
      actions?.push({
         payload: {
            requestType: 'POST',
            apiUrl: 'guardian/api/skyc/new/fetch-mnp-details/v1',
            authTokenGroup: 'SKYC_REVERIFICATION',
            body: {
               siNumber: portNumber,
               pincode: pincode,
               lob,
               flow,
               portingWidgetId
            },
         },
         type: 'apiCall',
      });
   }

   return onUserAction?.({
      actions,
   });
};

export const onSubRadioPressUtil = ({ args, onUserAction, getState }: any) => {
   const subJourney: string = args[0];
   let isMnp = subJourney?.includes('port');
   const actions: any[] = [];

   const analyticsActionObj = {
      analyticsAction: 'impression',
      analyticsData: {
         eVar21: '{{storeValues:appData.loggedInNumber}}',
         eventCategory: 'new_acq_postpaid_skyc_landing_page',
         section: 'step2',
         subSection: 'UserDetailsWidget',
         eventAction: 'pageloaded',
         prop45: isMnp ? 'mnp' : 'new connection',
         prop4: 'SKYC',
         prop9: '{{storeValues:appData.lob}}',
      },
      id: 'user-details-load',
   };

   actions?.push(analyticsActionObj);

   return onUserAction?.({
      actions,
   });
};

export const onDatePickedUtil = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const expiryDateReceived: string = args[1];
   const actions: any[] = [];
   //generationDate calculate
   //get circle from redux
   const donorCircleCode = storeValues?.portingContext?.previousCircleCode;
   const generationDate = new Date(expiryDateReceived.toString());
   const expiryDate = new Date(expiryDateReceived.toString());

   if (donorCircleCode == '117' || donorCircleCode == '122' || donorCircleCode == '123') {
      // if JK & NESA -> do this
      generationDate.setDate(expiryDate.getDate() - 15);
   } else {
      // else do that
      generationDate.setDate(expiryDate.getDate() - 4);
   }

   //format generated Date
   const upcMonth: number = generationDate.getMonth() + 1;
   const upcGeneratedDate: string =
      generationDate.getDate() + '/' + upcMonth + '/' + generationDate.getFullYear();

   //Store generation date in redux through actions
   const upcDateStoreAction = {
      payload: {
         data: {
            upcGeneratedDate: upcGeneratedDate,
         },
         context: 'portingContext',
      },
      type: 'storeValuesInRedux',
   };

   //Store expiry date in redux through actions

   //Analytics if needed

   // const analyticsActionObj = {
   //    "analyticsAction": "impression",
   //    "analyticsData": {
   //       "eVar21": "{{storeValues:appData.loggedInNumber}}",
   //       "eventCategory": "new_acq_postpaid_skyc_landing_page",
   //       "section": "step2",
   //       "subSection": "UserDetailsWidget",
   //       "eventAction": "pageloaded",
   //       "prop45": isMnp ? "mnp" : "new connection",
   //       "prop4": "SKYC"
   //    },
   //    "id": "user-details-load"
   // }

   actions?.push(upcDateStoreAction);

   return onUserAction?.({
      actions,
   });
};

export const onUpdateCartUserDetails = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const actions: any[] = [];
   const uniqueReferenceId = new Date().getTime().toString();

   actions?.push({
      payload: {
         requestType: 'POST',
         apiUrl: 'guardian/api/skyc/new/updateCart/v1',
         authTokenGroup: 'SKYC_REVERIFICATION',
         body: {
            data: {
               orderSubType: storeValues?.appData?.orderSubType,
               contactMedium: [
                  {
                     mediumType: 'alternateNumber',
                     characteristic: {
                        phoneNumber: storeValues?.appData?.msisdn,
                     },
                  },
                  {
                     mediumType: 'email',
                     characteristic: {
                        emailAddress: storeValues?.appData?.email,
                     },
                  },
               ],
               milestone: 'USER_DETAILS',
               channel: [
                  {
                     name: 'SHOP',
                  },
               ],
               id: storeValues?.orderData?.orderData?.cartId,
               cartItem: [
                  {
                     contactMedium: [
                        {
                           mediumType: 'billingAddress',
                           characteristic: {
                              city: '',
                              postCode: '',
                           },
                        },
                     ],
                     product: {
                        productCharacteristic: [
                           {
                              name: 'uniqueReferenceId',
                              value: {
                                 textValue: uniqueReferenceId,
                              },
                           },
                           {
                              name: 'productType',
                              value: {
                                 textValue: storeValues?.appData?.lob,
                              },
                           },
                           {
                              name: 'orderSubType',
                              value: {
                                 textValue: storeValues?.appData?.orderSubType,
                              },
                           },
                           {
                              name: 'acquisitionType',
                              value: {
                                 textValue: 'SKYC',
                              },
                           },
                           {
                              name: 'circleName',
                              valueType: 'textValue',
                              value: {
                                 textValue: '',
                              },
                           },
                           {
                              name: 'circleId',
                              valueType: 'textValue',
                              value: {
                                 textValue: '',
                              },
                           },
                        ],
                        realizingResource: [],
                     },
                     quantity: 1,
                     action: 'add',
                     id: storeValues?.orderData?.orderData?.cartItemId,
                  },
               ],
            },
            headers: {},
         },
      },
      type: 'apiCall',
   });

   return onUserAction?.({
      actions,
   });
};

export const showLinkListItemBasedOnLob = ({
   additionalData,
   onUserAction,
   getState,
}: any) => {
   let search = window.location.search;
   let params = new URLSearchParams(search);
   let lob = params.get('lob');
   let subLob = params.get('subLob');
   const actions: any[] = [];
   if (lob?.toUpperCase() === 'PREPAID') {
      actions.push({
         payload: {
            eventData: {
               hideOnPlatforms: [],
            },
            shouldResolveData: true,
            eventName: 'prepaidRechargeLinkListItemWidget',
         },
         type: 'nativeEventEmitter',
      });
   }

   if (subLob?.toUpperCase() == 'MNP') {
      actions.push({
         payload: {
            eventData: {
               heading: 'Activation takes up to 2 days',
            },
            shouldResolveData: true,
            eventName: 'activateLinkListItemWidget',
         },
         type: 'nativeEventEmitter',
      });
   }

   return onUserAction?.({
      actions,
   });
};

export const onGuardianNameChange = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const aadhaarName = storeValues?.kycDetails?.aadhaarName;
   const guardianName: string = args[0];
   const actions: any[] = [];

   if (guardianName.toLowerCase() === aadhaarName.toLowerCase()) {
      actions?.push({
         payload: {
            eventData: {
               //removeHintTextOnChange: true,
               'inputsDataProps.guardianName.hintText':
                  'The guardian name should not be same as your name. Please enter a different name.',
               'inputsDataProps.guardianName.state': 'error',
               'inputsDataProps.guardianName.value': guardianName,
            },
            eventName: 'step3Widget',
         },
         type: 'nativeEventEmitter',
      });
   } else {
      actions?.push({
         payload: {
            eventData: {
               //removeHintTextOnChange: true,
               'inputsDataProps.guardianName.hintText': '',
               'inputsDataProps.guardianName.state': 'none',
               'inputsDataProps.guardianName.value': guardianName,
            },
            eventName: 'step3Widget',
         },
         type: 'nativeEventEmitter',
      });
   }

   return onUserAction?.({
      actions,
   });
}

export const onRefreeNameChange = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const aadhaarName = storeValues?.kycDetails?.aadhaarName;
   const refreeName: string = args[0];
   const actions: any[] = [];

   if (refreeName.toLowerCase() === aadhaarName.toLowerCase()) {
      actions?.push({
         payload: {
            eventData: {
               //removeHintTextOnChange: true,
               "inputsDataProps.name.hintText": 'The Refree name should not be same as Aadhaar name. Please enter a different name.',
               "inputsDataProps.name.state": 'error',
               "inputsDataProps.name.isValid": false,
            },
            eventName: 'LOCAL_REFERENCE_DETAILS',
         },
         type: 'nativeEventEmitter',
      });
      actions?.push(
         {
            "payload": {
               "eventData": {
                  "leftCta": {
                     "disabled": true
                  }
               },
               "eventName": "submitButton"
            },
            "type": "nativeEventEmitter"
         }
      )
   } else {
      actions?.push({
         payload: {
            eventData: {
               //removeHintTextOnChange: true,
               "inputsDataProps.name.hintText": '',
               "inputsDataProps.name.state": 'none',
               "inputsDataProps.name.isValid": true,
            },
            eventName: 'LOCAL_REFERENCE_DETAILS',
         },
         type: 'nativeEventEmitter',
      });
   }
   return onUserAction?.({
      actions,
   });
}

export const fallbackRedirectionUtil = ({ args }: any) => {
   const url = args[0]

   const timeout = setTimeout(() => {
      window.location.replace(url)
   }, 15000);

   return () => clearTimeout(timeout);
}

export const maskSearchPattern = ({ args, onUserAction, getState }: any) => {
   const rawPattern = args?.[0] || '';
   const masked = '******' + rawPattern;

   return onUserAction?.({
      actions: [
         {
            type: 'storeValuesInRedux',
            payload: {
               context: 'numberContext',
               data: {
                  searchPattern: masked,  // "******1011" — used by API
               },
            },
         },
      ],
   });
};

export const handleSearchBarChangeText = ({ args, onUserAction, getState }: any) => {
   const searchValue = args?.[0] || '';
   const actions: any[] = [];

   if (searchValue.length == 0) {

      actions?.push({
         payload: {
            eventData: {
               'searchBarData.inputProps.appendItems.isPressable': true,
               'searchBarData.inputProps.appendItems.prefixIcon.iconColor': '#075EE8',
            },
            eventName: 'number_selection_widget_modal',
         },
         type: 'nativeEventEmitter',
      });
   } else {

      actions?.push({
         payload: {
            eventData: {
               'searchBarData.inputProps.appendItems.isPressable': false,
               'searchBarData.inputProps.appendItems.prefixIcon.iconColor': '#292C31',
            },
            eventName: 'number_selection_widget_modal',
         },
         type: 'nativeEventEmitter',
      });
   }
   actions?.push({
      type: 'storeValuesInRedux',
      payload: {
         context: 'numberContext',
         data: {
            searchPattern: '',
            rawSearchPattern: ''
         },
      },
   });

   return onUserAction?.({
      id: 'search-bar-text-change',
      actions,
   });
};

export const handleSearchBarUI = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const searchPattern = storeValues?.numberContext?.rawSearchPattern;
   const matchingChipsCount = storeValues?.numberContext?.matchingChipsCount;
   let firstChipListTopText = 'Showing best matching numbers for you';
   let secondChipListTopText = '';
   const actions: any[] = [];

   if (searchPattern) {
      firstChipListTopText = matchingChipsCount > 0 ? 'Showing exact matching numbers for you.' : 'No exact match found.'
      secondChipListTopText = matchingChipsCount > 0 ? '' : 'Try a different pattern or explore trending and easy to remember numbers below.'
   }

   actions?.push({
      "payload": {
         "eventData": {
            "searchBarData.inputProps.appendItems.isPressable": searchPattern ? true : false,
            "searchBarData.inputProps.appendItems.prefixIcon.iconColor": searchPattern ? '#075EE8' : "#292C31",
            "searchBarData.inputProps.value": searchPattern,
            //   "searchBarData.inputProps.clearInput": true,
            "firstChipListTopText": firstChipListTopText,
            "secondChipListTopText": secondChipListTopText
         },
         "shouldResolveData": false,
         "eventName": "number_selection_widget_modal"
      },
      "type": "nativeEventEmitter"
   });


   return onUserAction?.({
      id: 'search-bar-text-change',
      actions,
   });
};

export const handleVerificationPageOnload = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const msisdn = storeValues?.appData?.msisdn;
   const lob = storeValues?.appData?.lob;
   const actions: any[] = [];
   if (!msisdn && !lob) {
      actions?.push(
         {
            type: 'navigation',
            payload: {
               screenName: '/details',
               shouldAddSearchParams: true,
               params: {
                  screenQueryParams: {
                  },
               },
               type: 'replace',
            },
         },
      )
   }

   return onUserAction?.({
      actions,
   });
};

export const handleServiceSelection = ({ args, onUserAction, getState }: any) => {
   const isApp = isMobileApp();
   const isMobile = () => window.innerWidth < 768;
   const { storeValues } = getState();
   const selectedOrderSubType = args?.selectedOrderSubType as string;
   const orderSubType = storeValues?.appData?.orderSubType;
   const uniqueReferenceId = new Date().getTime().toString();

   const actions: any[] = [];

   // show/hide step 4 widget based on selected service
   if (selectedOrderSubType == "MNP") {
      if (isApp || isMobile()) {
         actions?.push({
            "payload": {
               "eventData": {
                  "showWidget": true,
                  "isExpanded": true,
                  "numberValue": ""
               },
               "eventName": "portingNumberWidget"
            },
            "type": "nativeEventEmitter"
         });
         actions?.push({
            "payload": {
               "eventData": {
                  "showWidget": false
               },
               "eventName": "portingFormDwebWidget"
            },
            "type": "nativeEventEmitter"
         });
         actions.push({
            "payload": {
               "data": {
                  "selectedNumber": ""
               },
               "context": "numberContext"
            },
            "type": "storeValuesInRedux"
         })
      } else {
         actions?.push({
            "payload": {
               "eventData": {
                  "showWidget": true,
                  "isExpanded": true,
               },
               "eventName": "portingFormDwebWidget"
            },
            "type": "nativeEventEmitter"
         });
      }
      actions?.push({
         "payload": {
            "eventData": {
               "hideOnPlatforms": [
                  "android-webview",
                  "ios-webview",
                  "mweb",
                  "dweb"
               ]
            },
            "eventName": "NumberSelectionWidget"
         },
         "type": "nativeEventEmitter"
      });

   } else {
      if (isApp || isMobile()) {
         actions?.push({
            "payload": {
               "eventData": {
                  "showWidget": false
               },
               "eventName": "portingNumberWidget"
            },
            "type": "nativeEventEmitter"
         });
         actions?.push({
            "payload": {
               "eventData": {
                  "showWidget": false
               },
               "eventName": "portingFormDwebWidget"
            },
            "type": "nativeEventEmitter"
         });
      } else {
         actions?.push({
            "payload": {
               "eventData": {
                  "showWidget": false
               },
               "eventName": "portingFormDwebWidget"
            },
            "type": "nativeEventEmitter"
         });
      }

      actions?.push({
         "payload": {
            "eventData": {
               "hideOnPlatforms": [],
               "isExpanded": false,
               "state": "disabled",
               "stepCalloutProps": {}
            },
            "eventName": "NumberSelectionWidget"
         },
         "type": "nativeEventEmitter"
      });
   }

   if (orderSubType !== selectedOrderSubType) {
      // actions - 1.store in redux 2. updateCart with service
      actions?.push({
         payload: {
            data: {
               orderSubType: selectedOrderSubType,
               orderType: selectedOrderSubType == "MNP" ? "MNP" : "NEW"
            },
            context: 'appData',
         },
         type: 'storeValuesInRedux',
      });

      actions?.push({
         payload: {
            requestType: 'POST',
            apiUrl: 'guardian/api/skyc/prepaid/updateCart/v1',
            authTokenGroup: 'SKYC_REVERIFICATION',
            queryParams: {},
            body: {
               data: {
                  serviceSelected: '{{storeValues:appData.lob}}',
                  orderSubType: selectedOrderSubType,
                  contactMedium: [
                     {
                        mediumType: 'alternateNumber',
                        characteristic: {
                           phoneNumber: '{{storeValues:appData.msisdn}}',
                        },
                     },
                  ],
                  milestone: 'SERVICE',
                  channel: [
                     {
                        name: 'SHOP',
                     },
                  ],
                  id: '{{storeValues:orderData.cartId}}',
                  cartItem: [
                     {
                        product: {
                           productCharacteristic: [
                              {
                                 name: 'uniqueReferenceId',
                                 value: {
                                    textValue: uniqueReferenceId,
                                 },
                              },
                              {
                                 name: 'productType',
                                 value: {
                                    textValue: '{{storeValues:appData.lob}}',
                                 },
                              },
                              {
                                 name: 'orderSubType',
                                 value: {
                                    textValue: selectedOrderSubType,
                                 },
                              },
                              {
                                 name: 'acquisitionType',
                                 value: {
                                    textValue: 'SKYC',
                                 },
                              },
                           ],
                           realizingResource: [],
                        },
                        quantity: 1,
                        action: 'add',
                        id: '{{storeValues:orderData.cartItemId}}',
                     },
                  ],
               },
            },
            loaderProps: {
               show: true
            }
         },
         type: 'apiCall',
      });
   } else {
      //  This block executes when user reselects same service
      //  collapse step3 and call fetchNumber , and from fetch Number expand step4-number selection widget
      actions?.push({
         payload: {
            "eventData": {
               "isExpanded": false,
               "state": "success",
               "stepDetailsProps.avatarIcon": "TickButtonIcon",
               "stepDetailsProps.avatarPosition": "center",
               "stepDetailsProps.heading": "Connection type",
               "stepDetailsProps.actionTypePosition": "center",
               "stepDetailsProps.actionTypeProps": { "buttonText": "change" },
               "stepDetailsProps.avatarProps": { "style": { "backgroundColor": "#18AF50" }, "iconProps": { "color": "#FFFFFF" } },
               "onStepDetailsCtaPressMetaData": {
                  id: 'service-change-cta',
                  actions: [
                     {
                        payload: {
                           args: [
                              {
                                 stepName: 'ServiceSelectionWidget',
                              },
                           ],
                           utilName: 'generateChangeActions',
                        },
                        type: 'callUtilFunction',
                     },
                     {
                        "actionWithDelayed": 0,
                        "payload": {
                           "eventData": {
                              "stepDetailsProps.subHeading": ""
                           },
                           "shouldResolveData": true,
                           "eventName": "ServiceSelectionWidget"
                        },
                        "type": "nativeEventEmitter"
                     }
                  ]
               },
               "stepDetailsProps.subHeading": selectedOrderSubType == "MNP" ? "Port to Airtel • Physical SIM" : "New Connection • Physical SIM",
            },

            "eventName": "ServiceSelectionWidget"
         },
         type: 'nativeEventEmitter'
      });
      if (selectedOrderSubType == "CYN") {
         actions?.push({
            "payload": {
               "header": {
                  "x-consumer-lob": "PREPAID"
               },
               "body": {
                  "circle": "{{storeValues:pincodeContext.pincodeDetails.circleCode}}",
                  "lob": "PREPAID",
                  "layout": "{{storeValues:journeyContext.layout}}"
               },
               "requestType": "POST",
               "apiUrl": "guardian/api/skyc/prepaid/fetch-numbers/v1",
               "queryParams": {},
               "authTokenGroup": "SKYC_REVERIFICATION",
               "loaderProps": {
                  "show": true
               }
            },
            "type": "apiCall"
         })
      }

   }

   //analytics action - radio selection(new/mnp)
   actions?.push({
      analyticsAction: 'click',
      analyticsData: {
         eventCategory: 'new_acq_postpaid_skyc_landing_page',
         section: 'Step3',
         subSection: 'ServiceSelectionWidget',
         eventAction: 'click',
         eVar0: selectedOrderSubType == "MNP" ? "skyc_mnp selection" : "skyc_prepaid selection",
         isInteractive: 1,
         eventValue: 'add connection details',
         eVar21: '{{storeValues:appData.msisdn}}',
         eVar20: '{{storeValues:appData.loggedInNumber}}',
         city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
         eVar36: '{{storeValues:numberContext.selectedNumber}}',
         eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleId}}',
         cartId: '{{storeValues:orderData.cartItemId}}',
         eventLabel: selectedOrderSubType == "MNP" ? "port to airtel" : "new prepaid",
         prop5: '{{storeValues:planInfo.planId}}',
         customLabel: 'button',
         prop45: '{{storeValues:appData.orderType}}',
         ticketId: '{{storeValues:orderData.cartId}}',
         prop26: '',
      }
   });

   return onUserAction?.({
      actions,
   });
};


export const handleValidLocalReferenceMobileNumber = ({
   additionalData,
   onUserAction,
   getState,
}: any) => {
   const { type } = additionalData?.queryParams ?? {};
   const { storeValues } = getState();
   const msisdn = storeValues?.appData?.localMsisdn;
   //TODO - new acq cicle and pincode passed 
   const activationCircle = storeValues?.pincodeContext?.pincodeDetails?.circleId;
   const activationPincode = storeValues?.pincodeContext?.pincodeDetails?.pincode;
   const actions: any[] = [];

   // check local refree eligibility and disable cta
   actions?.push(
      {
         "payload": {
            "requestType": "POST",
            "apiUrl": "guardian/api/skyc/prepaid/localRefreeEligibility/v1",
            "authTokenGroup": 'SKYC_REVERIFICATION',
            "header": {},
            "body": {
               msisdn,
               activationPincode,
               activationCircle
            }
         },
         "type": "apiCall"
      },
      {
         "payload": {
            "eventData": {
               "submitButtonProps": {
                  "leftCta": {
                     "disabled": true
                  }
               }
            },
            "eventName": "LOCAL_REFERENCE_DETAILS"
         },
         "type": "nativeEventEmitter"
      },
   )

   return onUserAction?.({
      actions,
   });
};

//TODO - testing pending in app webview
export const handleSendSMSPress = ({
   additionalData,
   onUserAction,
   getState,
}: any) => {
   const { storeValues } = getState();
   const portingNumber = storeValues?.numberContext?.selectedNumber;;
   const message = `PORT ${portingNumber}`;
   const smsUrl = `sms:1900?body=${encodeURIComponent(message)}`;

   // window.open(smsUrl, "_self");

   const actions: any[] = [];
   actions?.push(
      {
         type: 'navigation',
         payload: { externalUrl: smsUrl },
      },
   )

   return onUserAction?.({
      actions,
   });
};

export const handleValidCurrentAddressDetails = ({
   additionalData,
   onUserAction,
   getState,
}: any) => {
   const { storeValues } = getState();

   const isOutstation = coerceBoolean(storeValues?.outstationContext?.isOutstation);
   const isNewSKYCJourney = storeValues?.journeyContext?.journey === 'SKYC_NEW';

   const form = additionalData?.dataFromWidget ?? {};

   // Prefer redux flag (set via radio selection) over widget payload (not always provided)
   const reduxSameAsPermanent = storeValues?.billingAddressContext?.useAadhaarAddress;
   const widgetSameAsPermanent =
      coerceBoolean(form?.isSameAsPermanent) ||
      coerceBoolean(form?.sameAsPermanent) ||
      coerceBoolean(form?.radioValue) ||
      coerceBoolean(form?.selectedAddressRadio);

   const isSameAsPermanent =
      typeof reduxSameAsPermanent === 'boolean'
         ? reduxSameAsPermanent
         : widgetSameAsPermanent;

   const actions: any[] = [];

   const collapseEventName =
      additionalData?.eventName ||
      additionalData?.collapseEventName ||
      'CURRENT_ADDRESS_DETAILS_NEW';

   const expand = (eventName: string) => {
      actions.push({
         type: 'nativeEventEmitter',
         payload: {
            eventName,
            eventData: {
               isExpanded: true,
               state: 'none',
            },
         },
      });
   };

   // Collapse current widget
   actions.push({
      type: 'nativeEventEmitter',
      payload: {
         eventName: collapseEventName,
         eventData: {
            isExpanded: false,
            state: 'success',
         },
      },
   });

   if (isOutstation) {
      const nextEventName =
         additionalData?.outstationNextEventName || 'LOCAL_REFERENCE_DETAILS';
      expand(nextEventName);

      if (isNewSKYCJourney) {
         actions.push({
            analyticsAction: 'impression',
            analyticsData: {
               eventCategory: 'NEW_ACQ_POSTPAID_SKYC',
               section: 'stepsSection',
               subSection: nextEventName,
               eventAction: 'pageloaded',
               eventLabel: '',
               eventValue: '',
               customValue: '',
               customLabel: '',
               prop35: '{{storeValues:orderData.orderData.cartId}}',
               extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
               prop45: '{{storeValues:appData.subJourney}}',
               eVar21: '{{storeValues:appData.loggedInNumber}}',
               eVar36: '{{storeValues:appData.msisdn}}',
               city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
               eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
               prop4: 'SKYC',
               extraData11: '{{storeValues:layoutContext.layout}}',
               prop7: '{{storeValues:outstationContext.isOutstation}}',
               prop9: '{{storeValues:appData.lob}}',
            },
         });
      }

      return onUserAction?.({ actions });
   }

   const step4 = additionalData?.nonOutstationNextEventName || 'step4Widget';

   if (isSameAsPermanent) {
      expand(step4);
      return onUserAction?.({ actions });
   }

   // Flat redux shape
   const billing = storeValues?.billingAddressContext ?? {};

   const submitted = pickAddress({
      houseNo: form?.houseNoInput,
      street: form?.streetInput,
      area: form?.areaInput,
      landmark: form?.landmarkInput,
      city: form?.cityInput,
      district: form?.districtInput,
      state: form?.stateInput,
      pinCode: form?.pinCodeInput,
   });

   const prefilled = pickAddress(billing);

   const isUnchanged = (Object.keys(prefilled) as Array<keyof typeof prefilled>).every(
      (key) => {
         const submittedVal = submitted[key];
         if (submittedVal === '') return true;
         return submittedVal === prefilled[key];
      }
   );

   if (isUnchanged) {
      actions.push({
         type: 'nativeEventEmitter',
         actionWithDelayed: 3500,
         payload: {
            eventName: step4,
            eventData: {
               isExpanded: true,
               state: 'none',
            },
         },
      });
   }

   return onUserAction?.({ actions });
};

export const storeCurrentAddressRadioSelection = ({
   additionalData,
   onUserAction,
}: any) => {
   // This util is intentionally minimal; prefer PageSpace JSON storeValuesInRedux.
   return onUserAction?.({ actions: [] });
};

// --------------------
// Address helpers (used by CURRENT_ADDRESS_DETAILS_NEW flow)
// --------------------
const coerceBoolean = (v: any): boolean =>
   v === true || v === 'true' || v === 1 || v === '1';

const normalizeAddressValue = (v: any): string =>
   (v ?? '').toString().trim().toLowerCase();

const pickAddress = (obj: any) => ({
   houseNo: normalizeAddressValue(
      obj?.houseNo ?? obj?.['house no'] ?? obj?.houseNumber ?? obj?.house_number
   ),
   street: normalizeAddressValue(obj?.street ?? obj?.street1),
   area: normalizeAddressValue(obj?.area ?? obj?.locality),
   landmark: normalizeAddressValue(obj?.landmark),
   city: normalizeAddressValue(obj?.city),
   district: normalizeAddressValue(obj?.district),
   state: normalizeAddressValue(obj?.state ?? obj?.stateOrProvince),
   pinCode: normalizeAddressValue(
      obj?.pinCode ?? obj?.pinCode ?? obj?.pin_code ?? obj?.postCode
   ),
});

// Splits street1 into { street, area }.
// If more than 2 commas → split at 2nd comma (street = first 2 parts, area = rest).
// If 2 or fewer commas → split at 1st comma (street = first part, area = rest).
// Strips commas, hyphens and collapses whitespace from each part.
const splitStreet1 = (raw: string): { street: string; area: string } => {
   const clean = (s: string) => s.replace(/,/g, '').replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
   const truncate = (s: string) => {
      const limit = Math.floor(raw.length * 0.3);
      if (s.length <= limit) return s;
      const sliced = s.substring(0, limit);
      // trim to nearest word boundary
      const lastSpace = sliced.lastIndexOf(' ');
      return lastSpace !== -1 ? sliced.substring(0, lastSpace).trim() : sliced.trim();
   };
   const parts = raw.split(',');
   if (parts.length > 4) {
      const street = clean(parts.slice(0, 2).join(' '));
      const area = truncate(clean(parts.slice(2).join(' ')));
      return { street, area };
   }
   const firstComma = raw.indexOf(',');
   if (firstComma !== -1) {
      const area = truncate(clean(raw.substring(firstComma + 1)));
      return {
         street: clean(raw.substring(0, firstComma)),
         area,
      };
   }
   return { street: clean(raw), area: '' };
};

export const handleAadhaarSameSelection = ({
   additionalData,
   onUserAction,
   getState,
   args
}: any) => {

   const DOT_SYMBOL = '&#8226;'
   const actions: any[] = [];
   const { storeValues } = getState();
   const { billingAddressContext, aadhaarAddressContext } = storeValues
   const aadhaarSameSelection = additionalData?.dataFromWidget?.aadhaarSameSelection || ""

   if (aadhaarSameSelection === "NO") {
      const { street, area } = splitStreet1(billingAddressContext?.street1 || "");

      actions.push({
         type: "nativeEventEmitter",
         payload: {
            eventName: "CURRENT_ADDRESS_DETAILS_NEW",
            eventData: {
               "stepDetailsProps.subHeading": "",
               "inputsDataProps.houseNo.value": "",
               "inputsDataProps.street.value": street,
               "inputsDataProps.area.value": area,
               "inputsDataProps.landmark.value": "",
            }
         }
      })
      actions?.push({
         analyticsAction: 'click',
         analyticsData: {
            eventCategory: "new_acq_postpaid_skyc",
            section: "stepsSection",
            subSection: "CURRENT_ADDRESS_DETAILS_NEW",
            eVar33: "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
            eVar21: "{{storeValues:appData.msisdn}}",
            eVar20: "{{storeValues:appData.loggedInNumber}}",
            city: "{{storeValues:pincodeContext.pincodeDetails.city}}",
            customValue: "",
            eVar36: "{{storeValues:trackOrderContext.selectedMsisdn}}",
            eVar25: "{{storeValues:pincodeContext.pincodeDetails.circleId}}",
            isInteractive: 1,
            cartId: "{{storeValues:orderData.cartItemId}}",
            eventAction: "click",
            eventLabel: "no",
            prop5: "{{storeValues:planInfo.planName}}",
            prop4: "SKYC",
            eventValue: "address same as on aadhaar",
            eVar0: "skyc_click on no_aadhaar",
            customLabel: "button",
            prop45: "{{storeValues:appData.orderType}}",
            ticketId: "{{storeValues:orderData.cartId}}",
            prop26: ""
         }
      })
      actions?.push({
         payload: {
            data: {
               addressType: "LOCAL"
            },
            context: "selectedAddressType"
         },
         type: "storeValuesInRedux"
      })
      actions?.push({
         "payload": {
            "args": [
               {
                  "dataLayer": {
                     "stepName": "3|delivery address",
                     "clicktext": "",
                     "event": "delivery_address_change"
                  }
               }
            ],
            "utilName": "handleGtmDataLayerEvent"
         },
         "type": "callUtilFunction"
      })

      if (street) {
         actions?.push({
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: "new_acq_postpaid_skyc",
               section: "stepsSection",
               subSection: "CURRENT_ADDRESS_DETAILS_NEW",
               eVar33: "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
               eVar21: "{{storeValues:appData.msisdn}}",
               eVar20: "{{storeValues:appData.loggedInNumber}}",
               city: "{{storeValues:pincodeContext.pincodeDetails.city}}",
               customValue: "",
               eVar36: "{{storeValues:trackOrderContext.selectedMsisdn}}",
               eVar25: "{{storeValues:pincodeContext.pincodeDetails.circleId}}",
               isInteractive: 0,
               cartId: "{{storeValues:orderData.cartItemId}}",
               eventAction: "impression",
               eventLabel: "enter street/road name",
               prop5: "{{storeValues:planInfo.planName}}",
               prop4: "SKYC",
               eventValue: street,
               eVar0: "skyc_autofill of street/road name_delivery address",
               customLabel: "card",
               prop45: "{{storeValues:appData.orderType}}",
               ticketId: "{{storeValues:orderData.cartId}}",
               prop26: ""
            }
         })
      }
      if (area) {
         actions?.push({
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: "new_acq_postpaid_skyc",
               section: "stepsSection",
               subSection: "CURRENT_ADDRESS_DETAILS_NEW",
               eVar33: "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
               eVar21: "{{storeValues:appData.msisdn}}",
               eVar20: "{{storeValues:appData.loggedInNumber}}",
               city: "{{storeValues:pincodeContext.pincodeDetails.city}}",
               customValue: "",
               eVar36: "{{storeValues:trackOrderContext.selectedMsisdn}}",
               eVar25: "{{storeValues:pincodeContext.pincodeDetails.circleId}}",
               isInteractive: 0,
               cartId: "{{storeValues:orderData.cartItemId}}",
               eventAction: "impression",
               eventLabel: "enter area/sector",
               prop5: "{{storeValues:planInfo.planName}}",
               prop4: "SKYC",
               eventValue: area,
               eVar0: "skyc_autofill of area/sector/locality_delivery address",
               customLabel: "card",
               prop45: "{{storeValues:appData.orderType}}",
               ticketId: "{{storeValues:orderData.cartId}}",
               prop26: ""
            }
         })
      }
   } else {
      let area = aadhaarAddressContext?.locality
      let pincode = aadhaarAddressContext?.pincode
      let city = aadhaarAddressContext?.vtc
      let street = aadhaarAddressContext?.street
      let district = aadhaarAddressContext?.district
      let houseNo = aadhaarAddressContext?.houseNumber
      let state = aadhaarAddressContext?.state
      let landmark = aadhaarAddressContext?.landmark

      const subheading = [
         houseNo,
         street,
         area,
         landmark,
         pincode,
         city,
         district,
         state
      ]
         .filter(Boolean) // removes undefined, null, ''
         .join(` ${DOT_SYMBOL} `)

      actions.push(
         {
            payload: {
               data: {
                  area,
                  pincode,
                  city,
                  street,
                  district,
                  houseNo,
                  state,
                  landmark
               },
               context: "currentAddressDetails"
            },
            type: "storeValuesInRedux"
         },
         {
            type: "nativeEventEmitter",
            payload: {
               eventName: "CURRENT_ADDRESS_DETAILS_NEW",
               eventData: {
                  isExpanded: false,
                  state: "success",
                  "stepDetailsProps.subHeading": additionalData?.successStateSubHeading || "Same as Aadhaar"
               }
            }
         },
         {
            payload: {
               eventData: {
                  isExpanded: false,
                  state: "success"
               },
               eventName: "CURRENT_ADDRESS_DETAILS_NEW"
            },
            type: "nativeEventEmitter"
         },
         {
            payload: {
               eventData: {
                  isExpanded: true,
                  state: "none"
               },
               eventName: "step4Widget"
            },
            type: "nativeEventEmitter"
         },
         {
            payload: {
               data: {
                  addressType: "PERMANENT"
               },
               context: "selectedAddressType"
            },
            type: "storeValuesInRedux"
         }
      )
      actions?.push({
         analyticsAction: 'click',
         analyticsData: {
            eventCategory: "new_acq_postpaid_skyc",
            section: "stepsSection",
            subSection: "CURRENT_ADDRESS_DETAILS_NEW",
            eVar33: "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
            eVar21: "{{storeValues:appData.msisdn}}",
            eVar20: "{{storeValues:appData.loggedInNumber}}",
            city: "{{storeValues:pincodeContext.pincodeDetails.city}}",
            customValue: "",
            eVar36: "{{storeValues:trackOrderContext.selectedMsisdn}}",
            eVar25: "{{storeValues:pincodeContext.pincodeDetails.circleId}}",
            isInteractive: 1,
            cartId: "{{storeValues:orderData.cartItemId}}",
            eventAction: "click",
            eventLabel: "yes",
            prop5: "{{storeValues:planInfo.planName}}",
            prop4: "SKYC",
            eventValue: "address same as on aadhaar",
            eVar0: "skyc_click on yes_aadhaar",
            customLabel: "button",
            prop45: "{{storeValues:appData.orderType}}",
            ticketId: "{{storeValues:orderData.cartId}}",
            prop26: ""
         }
      })

      actions?.push({
         "payload": {
            "args": [
               {
                  "dataLayer": {
                     "stepName": "3|delivery address",
                     "clicktext": "",
                     "event": "delivery_address_submit"
                  }
               }
            ],
            "utilName": "handleGtmDataLayerEvent"
         },
         "type": "callUtilFunction"
      })
   }
   return onUserAction?.({ actions });
};
export const handleNewThankyouPage = ({ additionalData, onUserAction, getState }: any) => {
   const { storeValues } = getState?.() ?? {};

   const search = window.location.search;
   const params = new URLSearchParams(search);
   const requestID = params.get('requestID');
   const msisdnQ = params.get('msisdn');
   const orderTotalPrice = params.get('orderTotalPrice');
   const src = params.get('src');

   const altNumber = storeValues?.appData?.msisdn || ''

   const msisdn =
      storeValues?.trackOrderContext?.selectedMsisdn || msisdnQ;

   const planPrice =
      storeValues?.trackOrderContext?.orderTotalPrice || orderTotalPrice;

   const rechargeText = `${planPrice}`

   const calloutWidgetProps: any = {
      iconName: 'TickEnclosedIcon',
      state: 'success',
      title: 'First recharge successful',
      description: ''
   };

   if (msisdn || rechargeText) {
      const msisdnPart = msisdn ? ` for your new mobile number <${msisdn}>` : '';
      const rechargePart = rechargeText ? `Recharge of ₹${rechargeText} has been done` : 'Recharge has been done';
      calloutWidgetProps.description = `${rechargePart}${msisdnPart}`;
   }

   const subtitle = {
      multiText: [
         { text: 'Request ID : ' },
         { text: requestID, color: '#027bfc', isBold: true },
         { text: '\nOur agent will contact you shortly to confirm the delivery of your prepaid SIM.' },
      ],
      style: { marginTop: 7 },
      textAlignment: 'center',
   };

   const actions: any[] = [];
   if (requestID) {
      actions.push({
         type: 'nativeEventEmitter',
         payload: {
            eventName: 'statusCardWidget',
            eventData: {
               subtitle,
               calloutWidgetProps,
            },
            shouldResolveData: true,
         },
      });

      actions.push({
         type: 'nativeEventEmitter',
         payload: {
            eventName: 'stepperwidget',
            eventData: {
               "steps": [
                  {
                     "subHeadingProps": {
                        "color": "#6B7280",
                        "type": "body-para-sm"
                     },
                     "heading": "Receive your SIM",
                     "subHeading": "Your SIM will be delivered at your doorstep by our delivery partner.",
                     "stepNumber": "1",
                     "state": "default"
                  },
                  {
                     "subHeadingProps": {
                        "color": "#6B7280",
                        "type": "body-para-sm"
                     },
                     "heading": "Complete SIM activation",
                     "subHeading": `Once the SIM is delivered, you will receive an SMS with an activation link on your alternate number ${altNumber}. Open the link to activate your SIM.`,
                     "stepNumber": "2",
                     "state": "upcoming"
                  },
                  {
                     "subHeadingProps": {
                        "color": "#6B7280",
                        "type": "body-para-sm"
                     },
                     "heading": "Insert the SIM into your device",
                     "subHeading": "For better network connectivity, use SIM slot 1.",
                     "stepNumber": "3",
                     "state": "upcoming"
                  },
                  {
                     "subHeadingProps": {
                        "color": "#6B7280",
                        "type": "body-para-sm"
                     },
                     "heading": "SIM activation",
                     "subHeading": "Your SIM will be activated within 15 minutes. We will notify you via SMS once it is active.",
                     "stepNumber": "4",
                     "state": "upcoming"
                  }
               ]
            },
            shouldResolveData: true,
         },
      });

      if (src == "newAcq") {
         actions.push({
            type: 'showToast',
            payload: {
               title: 'Order already in progress.Once it is completed, you can raise a new request.',
               dismissDuration: 5000,
               position: 'bottom-center',
               version: 'variable-width',
               state: 'success',
               style: {
                  zIndex: 10000,
               },
            },
         });
      }

   } else {
      actions.push({
         type: 'navigation',
         payload: {
            id: 'redirection',
            screenName: '/verification',
            shouldAddSearchParams: true,
            params: {},
            type: 'replace',
         },
      });
   }

   return onUserAction?.({ actions });
};

export const updateEstimatedDeliveryInStepper = ({ additionalData, onUserAction, getState }: any) => {
   const { storeValues } = getState?.() ?? {};

   const eventName = additionalData?.eventName ?? 'NextStepsStepperWidget';
   const existingPrefix =
      additionalData?.prefix ??
      'Your SIM will be delivered at your doorstep by our delivery partner. \nEstimated delivery:';

   const estimated =
      storeValues?.trackOrderContext?.estimatedDeliveryDate ||
      storeValues?.trackOrderContext?.estimatedDelivery ||
      storeValues?.trackOrderContext?.deliveryEta ||
      storeValues?.trackOrderContext?.deliveryETA;

   if (!estimated) {
      // No-op if we don't have the value yet.
      return onUserAction?.({ actions: [] });
   }

   const subHeading = `${existingPrefix} ${estimated}`;

   return onUserAction?.({
      actions: [
         {
            type: 'nativeEventEmitter',
            payload: {
               eventName,
               eventData: {
                  // Update only the first step's subHeading.
                  'steps.0.subHeading': subHeading,
               },
               shouldResolveData: true,
            },
         },
      ],
   });
};

export const portNumberValidation = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const msisdn = storeValues?.appData?.msisdn;
   const portNumber = storeValues?.numberContext?.selectedNumber;

   const actions: any[] = [];

   if (portNumber === msisdn) {
      // show error
      actions?.push({
         payload: {
            eventData: {
               numberHintText: 'Porting number and alternate number cannot be the same.',
               numberState: 'error',
            },
            eventName: "portingNumberWidget",
         },
         type: 'nativeEventEmitter'
      });

      actions?.push({
         payload: {
            eventData: {
               isButtonDisabled: true,
               buttonWidgetProps: {
                  iconName: "SmartphoneIcon",
                  style: {
                     backgroundColor: "#A0A2A4",
                     borderColor: "#A0A2A4"
                  },
                  titleProps: {
                     text: "Send SMS to 1900",
                     style: {
                        color: "#696b6F"
                     }
                  }
               }
            },
            eventName: "portingNumberWidget",
         },
         type: 'nativeEventEmitter'
      });

      actions?.push({
         "analyticsAction": "impression",
         "analyticsData": {
            "eVar33": "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
            "eVar21": "{{storeValues:appData.msisdn}}",
            "eVar20": "{{storeValues:appData.loggedInNumber}}",
            "eventCategory": "NEW_ACQ_POSTPAID_SKYC_LANDING_PAGE",
            "city": "{{storeValues:pincodeContext.pincodeDetails.city}}",
            "customValue": "",
            "eVar36": "{{storeValues:numberContext.selectedNumber}}",
            "eVar25": "{{storeValues:pincodeContext.pincodeDetails.circleId}}",
            "isInteractive": 0,
            "cartId": "{{storeValues:orderData.cartItemId}}",
            "section": "Step4_porting",
            "eventAction": "error",
            "eventLabel": "this number cannot be same as the alternate number. try with another number",
            "prop5": "{{storeValues:planInfo.planId}}",
            "eventValue": "porting details",
            "eVar0": "skyc_error impression - porting number same as alternate number",
            "subSection": "portingNumberWidget",
            "customLabel": "card",
            "prop45": "{{storeValues:appData.orderType}}",
            "ticketId": "{{storeValues:orderData.cartId}}",
            "prop26": ""
         }
      })

   } else {
      // enable cta
      actions?.push({
         payload: {
            eventData: {
               isButtonDisabled: false,
               buttonWidgetProps: {
                  iconName: "SmartphoneIcon",
                  style: {
                     backgroundColor: "#000000",
                     borderColor: "#000000"
                  }
               }
            },
            eventName: "portingNumberWidget",
         },
         type: 'nativeEventEmitter'
      });

   }
   return onUserAction?.({
      actions,
   });
};

export const handleHomeNavigation = ({ onUserAction, args }: any) => {
   let url = 'https://www.airtel.in/';
   const actions = [];
   const { timeout = 0 } = args;

   if (isNativeApp({})) {
      setTimeout(() => {
         closeWebView();
      }, timeout)
   } else {
      actions.push({
         type: 'navigation',
         payload: { externalUrl: url, shouldAddSearchParams: false },
         actionWithDelayed: timeout
      });
   }

   return onUserAction({
      actions: actions,
   });
};

export const handleSimNumberValidation = ({ onUserAction, getState, args }: any) => {
   const { storeValues = {} } = getState()
   const { appData = {} } = storeValues
   const { upcExpired = false, simNumberLastSixDigits = "" } = appData
   const rawSimNumber = args[0]?.simNumber ?? '';
   const simNumber = (rawSimNumber || '')?.toString()?.toUpperCase();
   const actions: any[] = []

   actions.push({
      "payload": {
         "data": {
            "simNumber": simNumber
         },
         "context": "simNumberContext"
      },
      "type": "storeValuesInRedux"
   })

   if (upcExpired) {
      actions.push({
         payload: {
            eventData: {
               isExpanded: true,
               "linkListItemProps.disabled": false
            },
            shouldResolveData: true,
            eventName: "mnpWidget"
         },
         type: "nativeEventEmitter"
      })
      actions.push(
         {
            payload: {
               eventData: {
                  "linkListItemProps:actionType": simNumberLastSixDigits ? "none" : "button",
                  "linkListItemProps:actionTypeProps": {
                     "buttonText": simNumberLastSixDigits ? "" : "Change"
                  },
               },
               shouldResolveData: true,
               eventName: "simNumberWidget"
            },
            type: "nativeEventEmitter"
         })
   } else {
      actions.push({
         payload: {
            eventData: {
               "buttonData:leftCta:disabled": false
            },
            shouldResolveData: true,
            eventName: "ActivateNowWidget"
         },
         type: "nativeEventEmitter"
      })
   }

   return onUserAction?.({
      actions,
   })
};

export const handleMNPStepAction = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const isUpcCodeDisabled = storeValues?.portingInput?.isUpcCodeDisabled;

   const actions: any[] = [];

   if (!isUpcCodeDisabled) {
      actions?.push({
         payload: {
            authTokenGroup: 'SKYC_REVERIFICATION',
            requestType: 'POST',
            apiUrl: 'guardian/api/skyc/port-number-validation/v1',
            queryParams: {},
            transactUserGroup: '',
            header: {},
            body: {
               milestone: 'POQ',
               portingWidgetId: 'portingFormDwebWidget',
               upcCode: '{{storeValues:portingContext.upcCode}}',
               portNumber: '{{storeValues:numberContext.selectedNumber}}',
            },
         },
         type: 'apiCall',
      });
   }

   return onUserAction?.({
      actions,
   });
};

export const handleReserveNumber = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const selectedNumber = storeValues?.numberContext?.selectedNumber;
   const prevSelectedNumber = storeValues?.numberContext?.previousSelectedNumber;
   const chipsList = args[0]?.chipsList;

   const actions: any[] = [];

   if (selectedNumber !== prevSelectedNumber) {
      actions?.push({
         type: 'apiCall',
         payload: {
            authTokenGroup: 'SKYC_REVERIFICATION',
            requestType: 'POST',
            apiUrl: 'guardian/api/skyc/prepaid/reserve-number/v1',
            queryParams: {},
            header: {},
            body: {
               msisdn: '{{storeValues:numberContext.selectedNumber}}',
               lob: 'PREPAID',
               operationType: 'NUMBER_STATUS_UPDATE',
               statusType: 'RESERVE',
               auxiliaryMsisdn: '{{storeValues:numberContext.previousSelectedNumber}}',
               chipsList: chipsList,
            }
         },
      });
   } else {
      actions?.push({
         payload: {
            eventData: {
               isExpanded: false,
               state: 'success',
               'stepDetailsProps.subHeading':
                  '{{storeValues:numberContext.selectedNumber}}',
               successStateHeading: 'Prepaid number',
               onStepDetailsCtaPressMetaData: {
                  id: 'number-selection-change-cta',
                  actions: [
                     {
                        type: 'callUtilFunction',
                        payload: {
                           args: [
                              {
                                 stepName: 'NumberSelectionWidget',
                              },
                           ],
                           utilName: 'generateChangeActions',
                        },
                     },
                     {
                        payload: {
                           eventData: {
                              isExpanded: true,
                              'stepDetailsProps.heading': 'Select a new Prepaid number',
                              'stepDetailsProps.subHeading':
                                 'showing best matching numbers for you',
                              'stepDetailsProps.avatarProps': {
                                 style: {
                                    backgroundColor: '#DADFE7',
                                 },
                              },
                           },
                           eventName: 'NumberSelectionWidget',
                        },
                        type: 'nativeEventEmitter',
                     },
                  ],
               },
            },
            shouldResolveData: true,
            eventName: 'NumberSelectionWidget',
         },
         type: 'nativeEventEmitter',
      });

      actions?.push({
         payload: {
            header: {},
            requestType: 'GET',
            apiUrl: 'guardian/api/skyc/prepaid/fetch-plans/v1',
            queryParams: {
               lob: 'PREPAID',
               circle: '{{storeValues:pincodeContext.pincodeDetails.circleId}}',
               orderSubType: '{{storeValues:appData.orderSubType}}',
            },
            authTokenGroup: 'SKYC_REVERIFICATION',
            loaderProps: {
               show: true,
            },
         },
         type: 'apiCall',
      });
   }
   return onUserAction?.({
      actions,
   });
};

export const handleAnalyticsAction = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const queryMsisdn = storeValues?.additionalData?.queryParams?.msisdn || '';
   const msisdn = storeValues?.appData?.msisdn;
   const isMsisdnAutoFilled = queryMsisdn && queryMsisdn == msisdn
   const isCocp = args[0]?.journeyName == COCP;
   let eventLabel = '';
   let eVar0 = '';

   if (isCocp) {
      eVar0 = isMsisdnAutoFilled ? "cocp_mobile number auto filled" : "cocp_mobile number manually filled";
      eventLabel = isMsisdnAutoFilled ? "mobile number" : "enter your mobile number";
   } else {
      eVar0 = isMsisdnAutoFilled ? "skyc_alternate number auto filled" : "skyc_alternate number manually filled";
      eventLabel = isMsisdnAutoFilled ? "alternate mobile number" : "enter alternate mobile number";
   }

   const actions: any[] = [];
   actions?.push({
      "analyticsAction": isMsisdnAutoFilled ? "impression" : "click",
      "analyticsData": {
         "eVar33": "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
         "eVar21": isMsisdnAutoFilled ? queryMsisdn : msisdn,
         "eVar20": "{{storeValues:appData.loggedInNumber}}",
         "eventCategory": "NEW_ACQ_POSTPAID_SKYC_LANDING_PAGE",
         "city": "{{storeValues:pincodeContext.pincodeDetails.city}}",
         "eVar36": '{{storeValues:numberContext.selectedNumber}}',
         "eVar25": "{{storeValues:pincodeContext.pincodeDetails.circleId}}",
         "isInteractive": isMsisdnAutoFilled ? 0 : 1,
         "cartId": "{{storeValues:orderData.cartItemId}}",
         "section": "Step1",
         "eventAction": isMsisdnAutoFilled ? "impression" : "click",
         "eventLabel": eventLabel,
         "prop5": "{{storeValues:planInfo.planId}}",
         "eventValue": isMsisdnAutoFilled ? queryMsisdn : msisdn,
         "eVar0": eVar0,
         "subSection": "numberWidget",
         "customLabel": isMsisdnAutoFilled ? "card" : "button",
         "prop45": isCocp ? "cocp" : "{{storeValues:appData.orderType}}",
         "ticketId": "{{storeValues:orderData.cartId}}",
         "prop26": isMsisdnAutoFilled ? "auto" : "manual"
      }
   });


   return onUserAction?.({
      actions,
   });
};

export const handleDisabilitySelection = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const disabilitySelection = args[0];

   const actions: any[] = [];

   actions.push({
      analyticsAction: 'click',
      analyticsData: {
         eventCategory: "new_acq_postpaid_skyc",
         section: "stepsSection",
         subSection: "DISABILITY_INFO",
         eVar33: "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
         eVar21: "{{storeValues:appData.msisdn}}",
         eVar20: "{{storeValues:appData.loggedInNumber}}",
         city: "{{storeValues:pincodeContext.pincodeDetails.city}}",
         customValue: "",
         eVar36: "{{storeValues:trackOrderContext.selectedMsisdn}}",
         eVar25: "{{storeValues:pincodeContext.pincodeDetails.circleId}}",
         isInteractive: 1,
         cartId: "{{storeValues:orderData.cartItemId}}",
         eventAction: "click",
         eventLabel: disabilitySelection,
         prop5: "{{storeValues:planInfo.planName}}",
         prop4: "SKYC",
         eventValue: "disability status",
         eVar0: disabilitySelection == "no" ? "skyc_click on no_disability status" : "skyc_click on yes_disability status",
         customLabel: "button",
         prop45: "{{storeValues:appData.orderType}}",
         ticketId: "{{storeValues:orderData.cartId}}",
         prop26: ""
      },
   });

   actions?.push({
      "payload": {
         "args": [
            {
               "dataLayer": {
                  "stepName": "6|disability status",
                  "clicktext": disabilitySelection,
                  "event": "disability_status_submit"
               }
            }
         ],
         "utilName": "handleGtmDataLayerEvent"
      },
      "type": "callUtilFunction"
   })

   return onUserAction?.({
      actions,
   });
};


export const handleGtmDatalayer = (args: any, isLoggedIn: any, getState: any) => {
   const config = args?.[0];
   const currPage = window?.location?.pathname;
   const { storeValues } = getState();
   const stateSelected = storeValues?.appData?.state || ""
   const eventName = config?.dataLayer?.event || '';
   const stepName = config?.dataLayer?.stepName || '';
   const clicktext = config?.dataLayer?.clicktext || '';
   const offeravailed = config?.dataLayer?.offeravailed || '';
   const cartId = storeValues?.orderData?.cartId || "";
   const pincode = storeValues?.pincodeContext?.pincodeDetails?.pincode || "";
   const city = storeValues?.cityContext?.pincodeDetails?.city || "";
   const circleId = storeValues?.cityContext?.pincodeDetails?.circleId || "";
   const planId = storeValues?.planInfo?.planId || "";
   const planName = storeValues?.planInfo?.planName || "";
   const planPrice = storeValues?.planInfo?.planPrice || "";
   const data = storeValues?.planInfo?.planDetails?.dataBenefitString || "";
   const validityObj = storeValues?.planInfo?.planDetails?.validity;

   const validity = validityObj ? `${validityObj.duration} ${validityObj.unit}` : '';

   const SKYCConfig = {
      event: eventName,
      pincode,
      plan_name: planName,
      plan_price: planPrice,
      plan_data: data,
      plan_validity: validity,
      region_selected: circleId,
      clicktext,
      journey: 'prepaidrecharge',
      productname: '',
      productprice: '',
      cityname: city,
      plan_info: planId,
      productcategory: 'prepaid',
      loggedInStatus: isLoggedIn ? 'loggedin' : 'loggedout',
      planspeed: '',
      pageName: currPage,
      sessionId: getCookie('cs_sid')?.uuid || '',
      stepName,
      LeadID: cartId || '',
      offeravailed
   };
   window?.dataLayer?.push(SKYCConfig);
};

const getCookie = (name: string) => {
   const regex = new RegExp(name + '=([^;]+)');
   const value = regex.exec(document.cookie);
   return value != null ? JSON.parse(decodeURIComponent(value[1])) : null;
};

export const handleStepperUI = ({
   additionalData,
   onUserAction,
   getState,
   args,
}: any) => {
   const { storeValues } = getState?.() ?? {};

   const rawTAT = args[0]?.TAT;
   const cutoffTime = args[0]?.cutoffTime;
   const TAT = Number(String(rawTAT).trim());

   let infoTagText = '';

   if (cutoffTime && !isNaN(TAT)) {
      const [cutoffHour, cutoffMinute] = cutoffTime.split(':').map(Number);

      let deliveryDate = new Date();

      deliveryDate.setDate(deliveryDate.getDate() + TAT);

      // if cutoffTime >= 11:00 → +1 day
      if (cutoffHour > 11 || (cutoffHour === 11 && cutoffMinute >= 0)) {
         deliveryDate.setDate(deliveryDate.getDate() + 1);
      }

      let formattedDate = deliveryDate.toLocaleDateString('en-GB', {
         day: '2-digit',
         month: 'short',
         year: 'numeric',
      });

      // Convert first letter to uppercase
      formattedDate = formattedDate.replace(
         /\b([a-z]{3})\b/,
         (match) => match.charAt(0).toUpperCase() + match.slice(1)
      );
      // TODO - Commented for now - for delhi and gurgoan circle added hardcoded text
      // infoTagText = `Estimated delivery: ${formattedDate}`;
      infoTagText = 'Expected delivery by next working day';
   }

   const altNumber = storeValues?.appData?.msisdn || '';

   const actions: any[] = [];

   if (infoTagText != '') {
      actions.push({
         type: 'nativeEventEmitter',
         payload: {
            eventName: 'stepperwidget',
            eventData: {
               steps: [
                  {
                     subHeadingProps: {
                        color: '#6B7280',
                        type: 'body-para-sm',
                     },
                     heading: 'Receive your SIM',
                     subHeading:
                        'Your SIM will be delivered at your doorstep by our delivery partner.',
                     stepNumber: '1',
                     state: 'default',
                     infoSummaryProps: {
                        detailsDataCardList: [
                           {
                              detailsData: [
                                 {
                                    key: ' ',
                                    showKey: false,
                                    infoTagText: infoTagText,
                                    infoTagSubType: 'new',
                                    infoTagProps: {
                                       style: {
                                          marginTop: 0,
                                       },
                                    },
                                 },
                              ],
                           },
                        ],
                        outerContainerStyle: {
                           backgroundColor: 'rgba(0,0,0,0)',
                           borderWidth: 0,
                           shadowOpacity: 0,
                        },
                        style: {
                           paddingLeft: 0,
                           paddingRight: 0,
                           paddingTop: 0,
                        },
                     },
                  },
                  {
                     subHeadingProps: {
                        color: '#6B7280',
                        type: 'body-para-sm',
                     },
                     heading: 'Complete SIM activation',
                     subHeading: `Once the SIM is delivered, you will receive an SMS with an activation link on your alternate number ${altNumber}. Open the link to activate your SIM.`,
                     stepNumber: '2',
                     state: 'upcoming',
                  },
                  {
                     subHeadingProps: {
                        color: '#6B7280',
                        type: 'body-para-sm',
                     },
                     heading: 'Insert the SIM into your device',
                     subHeading: 'For better network connectivity, use SIM slot 1.',
                     stepNumber: '3',
                     state: 'upcoming',
                  },
                  {
                     subHeadingProps: {
                        color: '#6B7280',
                        type: 'body-para-sm',
                     },
                     heading: 'SIM activation',
                     subHeading:
                        'Your SIM will be activated within 15 minutes. We will notify you via SMS once it is active.',
                     stepNumber: '4',
                     state: 'upcoming',
                  },
               ],
            },
            shouldResolveData: true,
         },
      });
   }

   return onUserAction?.({ actions });
};

// COCP thank-you page — identical to handleNewThankyouPage but reads requestID
// from redux (skycContext.cafNumber) instead of the URL query param.
export const handleCocpThankyouPage = ({ additionalData, onUserAction, getState }: any) => {
   const { storeValues } = getState?.() ?? {};

   const search = window.location.search;
   const params = new URLSearchParams(search);
   const msisdnQ = params.get('msisdn');
   const orderTotalPrice = params.get('orderTotalPrice');
   const src = params.get('src');

   // Read requestID from query params (same as handleNewThankyouPage)
   const requestID = params.get('requestID') || '';

   const subtitle = {
      multiText: [
         { text: 'Request ID : ' },
         { text: requestID, color: '#027bfc', isBold: true },
         { text: '\nWe are verifying your KYC details. Once verified, your corporate number will be converted into a personal connection in 2 hours.' },
      ],
      style: { marginTop: 7 },
      textAlignment: 'center',
   };

   const actions: any[] = [];

   if (requestID) {
      actions.push({
         type: 'nativeEventEmitter',
         payload: {
            eventName: 'statusCardWidget',
            eventData: { subtitle },
            shouldResolveData: true,
         },
      });



      if (src === 'newAcq') {
         actions.push({
            type: 'showToast',
            payload: {
               title: 'Order already in progress. Once it is completed, you can raise a new request.',
               dismissDuration: 5000,
               position: 'bottom-center',
               version: 'variable-width',
               state: 'success',
               style: { zIndex: 10000 },
            },
         });
      }
   } else {
      actions.push({
         type: 'navigation',
         payload: {
            id: 'redirection',
            screenName: '/verification',
            shouldAddSearchParams: true,
            params: {},
            type: 'replace',
         },
      });
   }

   return onUserAction?.({ actions });
};

export const trackOrderNavigationAction = (props: any) => {
   const { onUserAction, args } = props as any;
   if (isMobileApp()) {
      const deeplink = 'myairtel://react?screenName=generic-nav-stack&selectedPage=track_requests';

      if (isNewIOSApp()) {
         //@ts-ignore
         window?.webkit?.messageHandlers?.openDeeplink?.postMessage(deeplink);
      } else {
         //@ts-ignore
         window?.MyAirtelAppReact?.launch(deeplink);
      }
   } else {
      let actions = {
         actions: [
            {
               "actionWithDelayed": 1000,
               "payload": {
                  "externalUrl": "https://www.airtel.in/track-request/"
               },
               "type": "navigation"
            }
         ],
      };
      onUserAction(actions);
   }
};

export const sendMessage = (eventdata: { height: number }) => {
   try {
      window.parent.postMessage(eventdata, '*');
   } catch (error) {
      fireLogWithSentryBase('commonUtils.ts-->sendMessage-->error in sendMessage', error);
   }
};

export let isOmniWidgetBackdropEnabled = false;

let initialObservedContentHeight = 0;
let lastSentHeight = 0;

export let resizeObserver = new ResizeObserver(
   debounce((entries: ResizeObserverEntry[]) => {
      const observedHeight =
         entries?.[0]?.contentBoxSize?.[0]?.blockSize ?? entries?.[0]?.contentRect?.height ?? 0;

      const currentContentHeight = Math.ceil(
         Math.max(
            observedHeight,
            document?.documentElement?.scrollHeight || 0,
            document?.body?.scrollHeight || 0
         )
      );

      if (!currentContentHeight) return;

      // lock to first full content height to prevent iframe-height feedback loops
      if (!initialObservedContentHeight) {
         initialObservedContentHeight = currentContentHeight;
      }

      let height = Math.min(currentContentHeight, initialObservedContentHeight);

      if (isOmniWidgetBackdropEnabled) height += 300;
      if (height === lastSentHeight) return;

      lastSentHeight = height;
      sendMessage({ height });
   }, 500)
);

export const checkEsimCompatiblity = ({ additionalData, onUserAction, getState, args }: any) => {

   const actions: any[] = [];
   let isEsimCompatible = false;


   if (isNativeApp({}) && isNewIOSApp()) {
      isEsimCompatible = true
   }

   //Store generation date in redux through actions
   const esimData = {
      payload: {
         data: {
            isEsimCompatible
         },
         context: 'appData',
      },
      type: 'storeValuesInRedux',
   };

   actions.push(esimData);
   onUserAction({ actions });

};

export const validatePortNumberRevamp = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const msisdn = storeValues?.appData?.msisdn;
   const portNumber = storeValues?.appData?.portingNumber;
   const pincode = storeValues?.pincodeContext?.pincodeDetails?.pincode;
   const lob = storeValues?.appData?.lob;
   const flow = storeValues?.appData?.flow;
   const portingWidgetId = storeValues?.portingWidgetId?.id;

   const actions: any[] = [];

   if (portNumber === msisdn) {

      actions?.push({
         payload: {
            eventData: {
               hintText: 'Porting number and alternate number cannot be the same.',
               state: 'error',
            },
            eventName: "portNumberInput",
         },
         type: 'nativeEventEmitter'
      });


   } else {
      actions?.push({
         "payload": {
            "authTokenGroup": "SKYC_REVERIFICATION",
            "requestType": "POST",
            "apiUrl": "guardian/api/buy/skyc/fetchmnpdetails/v1",
            "queryParams": {},
            "header": {},
            "body": {
               "pincode": "{{storeValues:appData.address.pincode}}",
               "siNumber": "{{storeValues:appData.portingNumber}}",
               "lob": "{{storeValues:appData.lob}}"
            }
         },
         "type": "apiCall"
      });
   }

   return onUserAction?.({
      actions,
   });
};


export const checkReduxData = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const msisdn = storeValues?.appData?.msisdn;
   const actions: any[] = [];

   if (!msisdn) {
      actions.push({
         type: 'navigation',
         payload: {
            id: 'redirection',
            screenName: '/new-sim',
            params: {},
            type: 'replace',
         },
      });
   }

   return onUserAction?.({
      actions,
   });
};


export const checkVerificationReduxData = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const msisdn = storeValues?.appData?.msisdn;
   const actions: any[] = [];

   if (!msisdn) {
      actions.push({
         type: 'navigation',
         payload: {
            id: 'redirection',
            screenName: '/verify',
            params: {},
            type: 'replace',
         },
      });
   }

   return onUserAction?.({
      actions,
   });
};


export const handleAadhaarDetail = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const documentId = storeValues?.appData?.kyc?.documentId;
   const documentType = documentId?.length === 12 ? 'A' : 'V';

   return onUserAction({
      actions: [
         {
            "payload": {
               "data": {
                  "kyc:documentType": documentType,
                  "kyc:documentId": documentId,
               },
               "context": "appData"
            },
            "type": "storeValuesInRedux"
         },
         {
            "payload": {
               "eventData": {
                  "buttonData.leftCta.disabled": false
               },
               "eventName": 'VerifyAadhaar_Cta',
            },
            "type": 'nativeEventEmitter',
         }

      ],
   });
};


export const checkWebType = () => {
   let isMobile = /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
   const url = 'https://www.airtel.in/kyc/prepaid-sim?utm_layout=prepaid_sim';
   if (!isMobile) {
      // dweb flow    
      window.open(url, "_self");
   }
}



export const handlefetchEID = async (onUserAction: any) => {
   const actions: any[] = [];

   await fetchEID()
      .then((res: any) => {
         if (isNewIOSApp()) {
            const obj = {
               "payload": {
                  "eventData": {
                     "value": res,
                     "readOnly": true
                  },
                  "eventName": "EIDInputWidget"
               },
               "type": "nativeEventEmitter"
            }
            if (res) {
               actions.push(obj);
            }
         }
      })
      .catch((err: any) => {
         console.error(`error while calling fetch eid 1..${err}`);
      });
   return onUserAction?.({
      actions,
   });
};



export const checkPlanBackButton = ({ onUserAction, args, getState }: any) => {
   const { storeValues } = getState();
   const isPhysicalSimFlow = storeValues?.appData?.isPhysicalSimFlow;
   const isEsimFlow = storeValues?.appData?.isPhysicalSimFlow;
   const actions: any[] = [];


   if (isPhysicalSimFlow && !isEsimFlow) {
      //new / buy sim screen
      actions.push({
         "type": "navigation",
         "payload": {
            "screenName": "/select-connection",
            "type": "push",
            "shouldAddSearchParams": true,
            "params": {}
         }
      })
   } else {
      actions.push({
         "type": "navigation",
         "payload": {
            "screenName": "/choose-sim-type",
            "type": "push",
            "shouldAddSearchParams": true,
            "params": {}
         }
      })
   }

   return onUserAction({
      actions: actions,
   });
};


export const handleAddressChange = ({ onUserAction, args, getState }: any) => {
   const { storeValues } = getState();
   const lob=storeValues?.appData?.lob;
    const actions: any[] = [];
        const modalSection = lob?.toLowerCase() == "prepaid" ? "AddressModalSectionPrepaid" : "AddressModalSectionPostpaid"
        actions.push({
                "payload": {
                        "modalData": {},
                        "modalSection": modalSection
                },
                "actionWithDelayed":500,
                "type": "openModal"
        })
    
   return onUserAction({
      actions: actions,
   });
};

       